<div class="breadcrum-container w-full px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:pt-4 bg-white">
  <app-breadcrum [isProductList]="false" [partType]="'Scrap Part'" [categoryName]="productCategory"
    [productName]="productName">
  </app-breadcrum>
</div>
<div class="Breadcrum px-4 sm:px-6 lg:px-8 pt-2 md:pt-4 bg-white">
  <div class="grid grid-cols-12 gap-4 lg:gap-6 max-md:flex max-md:flex-col">
    <!-- Left column (sticky on md+, full width on mobile) -->
    <div class="col-span-12 md:col-span-5 rounded-lg md:sticky md:top-16 md:self-start min-w-0">
      <div class="relative">
        <!-- Skeleton Loading State -->
        <div *ngIf="!productDetailData" class="w-full">
          <!-- Main Image Skeleton -->
          <div class="relative w-full bg-gray-200 rounded-lg overflow-hidden skeleton-shimmer">
            <div class="w-full h-[400px] max-sm:h-[247px] rounded-lg"></div>
          </div>

          <!-- Thumbnail Gallery Skeleton -->
          <div class="flex gap-4 mt-4 overflow-x-auto pb-2" *ngIf="!isMobile">
            <div *ngFor="let item of [1, 2, 3, 4, 5]"
              class="flex-shrink-0 w-[100px] h-[100px] rounded-lg overflow-hidden bg-gray-200 skeleton-shimmer"></div>
          </div>
        </div>

        <!-- Actual Images (when data is loaded) -->
        <div *ngIf="productDetailData">
          <!-- Main Image -->
          <div class="relative w-full bg-gray-100 rounded-lg overflow-hidden">
            <img [src]="images[activeImageIndex].url"
              class="MainImage object-cover w-full h-[247px] md:h-[320px] lg:h-[400px] rounded-lg"
              [alt]="images[activeImageIndex].alt" />
            <!-- Navigation Arrows -->
            <button (click)="prevImage()" *ngIf="images.length > 1"
              class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:bg-gray-100">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button (click)="nextImage()" *ngIf="images.length > 1"
              class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:bg-gray-100">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
            <!-- Favorite Button -->
            <button (click)="toggleFavorite(productDetailData)"
              class="absolute top-4 right-4 bg-white rounded-full p-2 shadow-md hover:bg-gray-100">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" [class.text-red-500]="isFavorite"
                [class.fill-current]="isFavorite" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </button>
          </div>

          <!-- Thumbnail Gallery -->
          <div class="flex gap-4 mt-4 overflow-x-auto pb-2" *ngIf="!isMobile">
            <div *ngFor="let image of images; let i = index"
              class="flex-shrink-0 cursor-pointer relative w-[100px] h-[100px] rounded-lg overflow-hidden border-2"
              [class.border-blue-500]="activeImageIndex === i" (click)="setActive(i)">
              <img [src]="image.url" class="object-cover w-full h-full" [alt]="image.alt" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Middle column -->
    <div class="col-span-12 md:col-span-4 rounded-lg min-w-0">
      <section class="MidCol mx-auto w-full">
        <header class="flex flex-col w-full mt-3 md:mt-0">
          <div class="flex gap-3 items-start w-full text-xl font-bold leading-snug text-black justify-between">
            <h1 class="w-full min-w-0">
              {{ productDetailData?.part_detail | productName }}
            </h1>

            <img (click)="openSocialSharePopup()"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/f4926ffc9587d5f5f6ab7f69c5261126f5b38df5?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
              alt="Product icon" class="cursor-pointer shrink-0 w-6 h-6 mt-1" />
          </div>

          <div *ngIf="!isScrapPart" class="text-sm mt-2 text-black">
            <span class="self-stretch my-auto">
              {{ productDetailData?.part_detail?.DISTRIBUTOR_CATEGORY_s }}
            </span>
            <span class="self-stretch my-auto">
              {{ productDetailData?.part_detail?.TEVM_VEHICLE_MAKE_s }}
            </span>
            <span class="self-stretch my-auto">
              {{ productDetailData?.part_detail?.make }}
            </span>
            <span *ngIf="productDetailData?.part_detail?.make" class="self-stretch my-auto">
              •
            </span>
            <!-- <span class="self-stretch my-auto"> • </span> -->
            <span class="self-stretch my-auto">
              {{ productDetailData?.part_detail?.model }}
            </span>
            <span *ngIf="
                productDetailData?.part_detail?.material &&
                productDetailData?.part_detail?.part_type === 'Scrap Part'
              " class="self-stretch my-auto text-gray-500">
              {{ productDetailData?.part_detail?.material }}
            </span>
            <!-- <span class=" text-sm my-auto">
              {{ productDetailData?.part_detail?.model | slice:0:15 }}</span> -->

            <span class="self-stretch my-auto" *ngIf="productDetailData?.part_detail?.year_of_manufacture">
              •
            </span>
            <span class="self-stretch my-auto" *ngIf="productDetailData?.part_detail?.year_of_manufacture">
              {{ productDetailData?.part_detail?.year_of_manufacture }}</span>
            <span class="self-stretch my-auto" *ngIf="productDetailData?.part_detail?.variant">
              •
            </span>
            <!-- <span class="self-stretch my-auto">
              {{ productDetailData?.part_detail?.GROUP_NAME_s }}</span
            >
            <span class="self-stretch my-auto"> • </span> -->
            <span class="self-stretch my-auto">
              {{
              productDetailData?.part_detail?.variant | slice: 0 : 15
              }}</span>
          </div>
        </header>
        <section class="flex justify-between mt-4 w-full" *ngIf="!isScrapPart">
          <div class="flex gap-3 items-center self-stretch my-auto font-bold min-w-60"
            *ngIf="productDetailData?.part_detail?.quality_s">
            @if (productDetailData?.part_detail?.quality_s) {
            <div [ngClass]="
                  productDetailData?.part_detail?.quality_s === 'A'
                    ? 'bg-green-100 text-green-800'
                    : productDetailData?.part_detail?.quality_s === 'B'
                      ? 'bg-yellow-100 text-yellow-800'
                      : productDetailData?.part_detail?.quality_s === 'C'
                        ? 'bg-orange-100 text-orange-800'
                        : 'bg-green-100 text-green-800'
                "
              class="flex gap-1 items-center self-stretch px-1 py-0.5 my-auto text-sm leading-none whitespace-nowrap rounded-none">
              <svg *ngIf="productDetailData?.part_detail?.quality_s" [attr.title]="
                    'Quality grade: ' +
                    productDetailData?.part_detail?.quality_s
                  " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="max-sm:w-5 max-sm:h-5">
                <!-- Background rectangle with rounded corners -->
                <rect width="24" height="24" rx="4" [attr.fill]="
                      productDetailData?.part_detail?.quality_s === 'A'
                        ? '#01811D'
                        : productDetailData?.part_detail?.quality_s === 'B'
                          ? '#B8860B'
                          : productDetailData?.part_detail?.quality_s === 'C'
                            ? '#D35400'
                            : '#01811D'
                    " />

                <!-- Dynamic letter inside the SVG -->
                <text [attr.x]="12" [attr.y]="16" text-anchor="middle" font-size="14" font-family="Arial, sans-serif"
                  fill="white">
                  {{ productDetailData?.part_detail?.quality_s }}
                </text>
              </svg>
              <span class="text-lg font-bold" [ngClass]="
                    productDetailData?.part_detail?.quality_s === 'A'
                      ? 'text-green-800'
                      : productDetailData?.part_detail?.quality_s === 'B'
                        ? 'text-yellow-800'
                        : productDetailData?.part_detail?.quality_s === 'C'
                          ? 'text-orange-800'
                          : 'text-green-800'
                  ">Quality</span>
            </div>
            }
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/f911f58fd5e561558f5f78e7685372693a74dde9?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
              alt="Divider"
              class="object-contain shrink-0 self-stretch aspect-[0.04] stroke-[1px] stroke-neutral-300 sm:-mx-0 md:-mx-2" />
            <p class="self-stretch my-auto text-xs leading-none text-neutral-500 w-[197px] sm:text-xs md:text-[10px]">
              Reliable & tested.
            </p>
          </div>
          <a *ngIf="productDetailData?.part_detail?.quality_s"
            class="self-stretch my-auto font-medium text-center text-blue-500 cursor-pointer whitespace-nowrap sm:font-sm"
            (click)="openGradingGuide()">
            <span style="color: rgba(48, 127, 225, 1)"> Grading Guide </span>
          </a>
        </section>
        @if (isMobile) {
        <div class="flex-1 w-full rounded-lg" *ngIf="isMobile">
          <section class="w-full">
            <article class="w-full">
              <!-- View Compatibility -->
              <section
                class="flex flex-col items-start justify-center mt[-14px] w-full text-base font-bold text-blue-500"
                *ngIf="!isScrapPart">
                <div class="flex items-start w-full">
                  <div class="flex items-center gap-1 rounded-xl min-h-8 w-full">
                    <button
                      class="flex items-center gap-2 my-auto cursor-pointer hover:opacity-80 transition-opacity relative z-10"
                      (click)="scrollToCompareSection()" type="button">
                      <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/33156f53d14239f34c20fcf3406bdea8b5a10be4?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                        class="w-6 aspect-square object-contain" alt="Compatibility icon" />
                      <span class="cursor-pointer">View compatibility</span>
                    </button>
                  </div>
                </div>
              </section>

              <!-- Price Section -->
              <div class="flex flex-col mb-6 w-full">
                <div class="w-full">
                  <div class="flex items-center gap-1 h-7 w-full">
                    <h2 class="text-2xl font-bold text-black whitespace-nowrap" *ngIf="!isScrapPart">
                      <!-- ₹{{productDetailData?.part_detail?.price_s}}> -->
                      ₹{{
                      productDetailData?.part_detail?.discounted_price
                      ? productDetailData?.part_detail?.discounted_price
                      : productDetailData?.part_detail?.price_s
                      }}
                    </h2>
                    <div class="flex items-center gap-1.5" *ngIf="
                          productDetailData?.part_detail?.discounted_price &&
                          productDetailData?.part_detail?.discount_percentage &&
                          productDetailData?.part_detail?.discount_percentage >
                            0
                        ">
                      <p class="text-base font-medium text-neutral-500 line-through" *ngIf="!isScrapPart">
                        ₹{{ productDetailData?.part_detail?.price_s }}
                      </p>
                      <span class="text-sm font-bold text-white bg-emerald-800 px-1.5 rounded-[40px] min-h-6" *ngIf="
                            productDetailData?.part_detail
                              ?.discount_percentage &&
                            !isScrapPart &&
                            productDetailData?.part_detail
                              ?.discount_percentage > 0
                          ">{{
                        productDetailData?.part_detail?.discount_percentage
                        }}% Off</span>
                    </div>
                  </div>
                </div>

                <div *ngIf="isScrapPart" class="-mt-[49px] sm:mt-0">
                  <!-- Price and discount -->

                  <!-- <span class="text-sm font-medium leading-none sm:-mt-10">{{
                      productDetailData?.part_detail?.scrap_category
                    }}</span> -->

                  <div class="flex items-center gap-2 mt-3">
                    <p class="text-lg font-semibold">
                      ₹{{
                      productDetailData?.part_detail?.discounted_taxable
                      ? productDetailData?.part_detail?.discounted_taxable
                      : productDetailData?.part_detail?.taxable_amount
                      }}/<ng-container *ngIf="
                            isOilProductWithLiter(
                              productDetailData?.part_detail
                            );
                            else showKgPrice
                          ">Ltr</ng-container><ng-template #showKgPrice>Kg</ng-template>
                    </p>
                    <p class="text-sm line-through text-gray-500" *ngIf="
                          productDetailData?.part_detail?.discount_percentage
                        ">
                      ₹{{ productDetailData?.part_detail?.taxable_amount }}
                    </p>
                    <span class="text-xs text-white rounded-[16px] bg-[#006C3B] px-2 py-0.5" *ngIf="
                          productDetailData?.part_detail?.discount_percentage &&
                          productDetailData?.part_detail?.discount_percentage >
                            0
                        ">
                      {{
                      productDetailData?.part_detail?.discount_percentage
                      }}% off</span>
                  </div>

                  <!-- Min & Max Order Qty -->
                  <div class="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2">
                    <div class="whitespace-nowrap">
                      <span class="text-[#777] text-[14px] font-medium leading-[20px]">Min Booking Qty : </span>
                      <span class="text-black text-[14px] font-bold leading-[20px]">
                        <!-- Show min qty in selected unit -->
                        <ng-container *ngIf="unit === 'kg'">
                          {{
                          productDetailData?.part_detail?.min_quantity ||
                          productDetailData?.part_detail?.min_qty ||
                          0
                          }}
                          kg
                        </ng-container>
                        <ng-container *ngIf="!unit || unit === 'ton'">
                          {{
                          (productDetailData?.part_detail?.min_quantity ||
                          productDetailData?.part_detail?.min_qty ||
                          0) / 1000
                          }}
                          ton
                        </ng-container>
                        <ng-container *ngIf="unit === 'liter'">
                          {{
                          productDetailData?.part_detail?.min_quantity ||
                          productDetailData?.part_detail?.min_qty ||
                          0
                          }}
                          ltr
                        </ng-container>
                      </span>
                    </div>
                    <div class="whitespace-nowrap">
                      <span class="text-[#777] text-[14px] font-medium leading-[20px]">Max Booking Qty : </span>
                      <span class="text-black text-[14px] font-bold leading-[20px]">
                        <ng-container *ngIf="unit === 'kg'">
                          {{
                          productDetailData?.part_detail?.max_booking_qty ||
                          productDetailData?.part_detail?.max_booking_quantity ||
                          productDetailData?.part_detail?.max_quantity ||
                          productDetailData?.part_detail?.available_quantity ||
                          0
                          }}
                          kg
                        </ng-container>
                        <ng-container *ngIf="!unit || unit === 'ton'">
                          {{
                          (productDetailData?.part_detail?.max_booking_qty ||
                          productDetailData?.part_detail?.max_booking_quantity ||
                          productDetailData?.part_detail?.max_quantity ||
                          productDetailData?.part_detail?.available_quantity ||
                          0) / 1000
                          }}
                          ton
                        </ng-container>
                        <ng-container *ngIf="unit === 'liter'">
                          {{
                          productDetailData?.part_detail?.max_booking_qty ||
                          productDetailData?.part_detail?.max_booking_quantity ||
                          productDetailData?.part_detail?.max_quantity ||
                          productDetailData?.part_detail?.available_quantity ||
                          0
                          }}
                          ltr
                        </ng-container>
                      </span>
                    </div>
                  </div>

                  <!-- Quantity Label -->
                  <div class="hidden sm:block text-[#464646] text-[12px] font-medium leading-[16px] mt-2">
                    Quantity :
                  </div>

                  <!-- Quantity Input and Selector -->
                  <!-- Quantity Input and Selector -->

                  <!-- Wrapper for Address + Quantity Buttons -->
                  <div class="flex flex-col sm:flex-row items-start sm:gap-4 w-full">
                    <!-- Address container -->
                    <!-- Address container -->
                    <div
                      class="flex flex-wrap items-center mt-[9px] mr-1 gap-y-2 w-full h-[40px] sm:w-auto sm:h-auto sm:flex-row">
                      <div
                        class="flex w-full max-w-[200px] border border-[#D4D4D4] rounded-[7px] h-10 pl-2 items-center gap-1 shrink-0">
                        <!-- Quantity Input -->
                        <input type="number" [ngModel]="quantity" (ngModelChange)="onQuantityChange($event)"
                          [min]="minQuantity" [max]="maxQuantity" (blur)="onQuantityInput()"
                          class="text-sm px-1 py-1 w-full sm:w-[70px] border-none focus:outline-none focus:ring-0 text-black text-[16px] font-bold leading-[24px]" />

                        <!-- divider for desktop -->
                        <!-- <div
                          class="hidden sm:block w-px h-[39px] ml-[-6px] bg-[#D4D4D4]"
                        ></div> -->

                        <!-- Select container with border-left in mobile -->
                        <div class="border-l border-l-[1px] border-[#D4D4D4] h-full flex items-center px-1">
                          <select [(ngModel)]="unit" (change)="onUnitChange()"
                            class="text-sm border-none focus:outline-none focus:ring-0 text-center text-black font-medium">
                            <option value="ton" *ngIf="
                                  !isOilProductWithLiter(
                                    productDetailData?.part_detail
                                  )
                                ">
                              ton
                            </option>
                            <option value="kg" *ngIf="
                                  !isOilProductWithLiter(
                                    productDetailData?.part_detail
                                  )
                                ">
                              kg
                            </option>
                            <option value="liter" *ngIf="
                                  isOilProductWithLiter(
                                    productDetailData?.part_detail
                                  )
                                ">
                              ltr
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- Quick Quantity Buttons -->
                    <div
                      class="max-sm:grid max-sm:grid-cols-4 max-sm:gap-2 max-sm:w-full max-sm:mt-[12px] max-sm:ml-0 sm:flex sm:gap-2 sm:ml-0 sm:mt-2">
                      <button *ngFor="let qty of quickQuantities" (click)="selectQuantity(qty)" [ngClass]="{
                          'border border-[#307FE1] text-blue-600 sm:bg-[rgba(192,216,246,0.2)]':
                            isQuickQuantitySelected(qty),
                          'border border-gray-300 text-black bg-white':
                            !isQuickQuantitySelected(qty)
                        }"
                        class="w-full max-sm:py-1 max-sm:w-[75px] max-sm:h-[41px] sm:flex sm:w-16 sm:p-2 sm:flex-col sm:justify-center sm:items-center sm:gap-1 sm:self-stretch rounded text-sm font-medium text-center">
                        {{ getQuickQuantityDisplay(qty) }} ton
                      </button>
                    </div>
                  </div>

                  <!-- Error messages for mobile view (matching product-list pattern) -->
                  <div *ngIf="
                        quantityTouched &&
                        (isScrapPart ||
                          productDetailData?.part_detail?.part_type ===
                            'Scrap Part') &&
                        (getSelectedQuantityInKg() === 0 ||
                          getSelectedQuantityInKg() === null ||
                          getSelectedQuantityInKg() === undefined)
                      "
                    class="block sm:hidden text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
                    Please select a quantity
                  </div>
                  <div *ngIf="
                        quantityTouched &&
                        (isScrapPart ||
                          productDetailData?.part_detail?.part_type ===
                            'Scrap Part') &&
                        getSelectedQuantityInKg() > 0 &&
                        getSelectedQuantityInKg() <
                          (productDetailData?.part_detail?.min_quantity ||
                            productDetailData?.part_detail?.min_qty ||
                            0)
                      "
                    class="block sm:hidden text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
                    Minimum quantity is
                    <span *ngIf="unit === 'kg'">{{
                      productDetailData?.part_detail?.min_quantity ||
                      productDetailData?.part_detail?.min_qty ||
                      0
                      }}
                      kg</span><span *ngIf="unit === 'ton'">{{
                      (productDetailData?.part_detail?.min_quantity ||
                      productDetailData?.part_detail?.min_qty ||
                      0) / 1000
                      }}
                      ton</span><span *ngIf="unit === 'liter'">{{
                      productDetailData?.part_detail?.min_quantity ||
                      productDetailData?.part_detail?.min_qty ||
                      0
                      }}
                      ltr</span>
                  </div>
                  <div *ngIf="
                        quantityTouched &&
                        (isScrapPart ||
                          productDetailData?.part_detail?.part_type ===
                            'Scrap Part') &&
                        getSelectedQuantityInKg() > 0 &&
                        getSelectedQuantityInKg() >
                          (productDetailData?.part_detail?.max_booking_qty ||
                            productDetailData?.part_detail
                              ?.max_booking_quantity ||
                            productDetailData?.part_detail?.max_quantity ||
                            productDetailData?.part_detail?.available_quantity ||
                            0)
                      "
                    class="block sm:hidden text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
                    Maximum available quantity is
                    <span *ngIf="unit === 'kg'">{{
                      productDetailData?.part_detail?.max_booking_qty ||
                      productDetailData?.part_detail
                      ?.max_booking_quantity ||
                      productDetailData?.part_detail?.max_quantity ||
                      productDetailData?.part_detail?.available_quantity ||
                      0
                      }}
                      kg</span><span *ngIf="unit === 'ton'">{{
                      (productDetailData?.part_detail?.max_booking_qty ||
                      productDetailData?.part_detail
                      ?.max_booking_quantity ||
                      productDetailData?.part_detail?.max_quantity ||
                      productDetailData?.part_detail?.available_quantity ||
                      0) / 1000
                      }}
                      ton</span><span *ngIf="unit === 'liter'">{{
                      productDetailData?.part_detail?.max_booking_qty ||
                      productDetailData?.part_detail
                      ?.max_booking_quantity ||
                      productDetailData?.part_detail?.max_quantity ||
                      productDetailData?.part_detail?.available_quantity ||
                      0
                      }}
                      ltr</span>
                  </div>
                </div>
                <div class="block md:hidden" *ngIf="isScrapPart">
                  <div class="flex justify-between items-center mb-[10px] mt-[25px]">
                    <span class="text-[#464646] font-bold text-[18px] leading-[24px]">Base Price</span>
                    <p class="text-black font-bold text-base leading-[28px]">
                      ₹{{ getBasePrice() > 0 ? (getBasePrice() | number: "1.2-2") : '0' }}
                    </p>
                  </div>
                  <div class="flex justify-between items-center">
                    <span class="text-[#777777] font-medium text-[14px] leading-[20px]">
                      Scrap Booking Amount
                      <!-- <span *ngIf="getBookingPercentage()" class="text-xs font-bold text-blue-600 ml-1">
                        ({{ getBookingPercentage() }}%)
                      </span> -->
                    </span>
                    <p class="text-black text-sm leading-[20px]">
                      ₹{{ formatPriceBreakup(priceBreakup?.scrap_booking_amount ||
                      productDetailData?.part_detail?.booking_amount) }}
                    </p>
                  </div>
                  <div class="flex items-start gap-2 text-xs leading-[18px] text-[#0A0A5F] mt-[10px]"
                    *ngIf="getBalanceAmount() > 0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"
                      class="mt-[2px] shrink-0">
                      <g clip-path="url(#clip0_2215_27824)">
                        <path
                          d="M8.00073 0.666748C12.0505 0.667144 15.3337 3.95089 15.3337 8.00073C15.3333 12.0502 12.0502 15.3333 8.00073 15.3337C3.95089 15.3337 0.667144 12.0505 0.666748 8.00073C0.666748 3.95064 3.95064 0.666748 8.00073 0.666748ZM8.00073 2.00073C4.68702 2.00073 2.00073 4.68702 2.00073 8.00073C2.00113 11.3141 4.68727 14.0007 8.00073 14.0007C11.3139 14.0003 14.0003 11.3139 14.0007 8.00073C14.0007 4.68727 11.3141 2.00113 8.00073 2.00073ZM8.00073 6.66675C8.36859 6.66714 8.66675 6.96579 8.66675 7.33374V11.3337C8.66653 11.7015 8.36845 12.0003 8.00073 12.0007C7.63268 12.0007 7.33396 11.7017 7.33374 11.3337V7.33374C7.33374 6.96555 7.63254 6.66675 8.00073 6.66675ZM7.99976 3.99976C8.36795 3.99976 8.66675 4.29856 8.66675 4.66675C8.6667 5.0349 8.36792 5.33374 7.99976 5.33374C7.63171 5.33361 7.33378 5.03482 7.33374 4.66675C7.33374 4.29864 7.63168 3.99989 7.99976 3.99976Z"
                          fill="black" />
                      </g>
                      <defs>
                        <clipPath id="clip0_2215_27824">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p class="text-[#0A0A5F] font-medium text-[14px] leading-[20px]">
                      The balance amount of ₹{{ getBalanceAmount() | number: "1.2-2" }} is to be paid at the time of
                      store pickup.
                    </p>
                  </div>
                </div>

                <div *ngIf="isProductLocked()"
                  class="flex items-start gap-2 text-[#E30613] text-[12px] leading-[18px] mt-[10px] -ml-1">
                  <!-- <div class="flex items-center gap-2 text-[#E30613] text-[12px] font-bold max-md:text-base"> -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16">
                    <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />
                    <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />
                    <circle cx="16" cy="23" r="2" fill="red" />
                  </svg>
                  <span>This part is no longer available for purchase.</span>
                </div>

                <!-- Exchange Offer -->
                <section *ngIf="!isScrapPart"
                  class="flex flex-col items-center justify-center mt-4 p-2 bg-white border border-gray-300 rounded-lg rounded-md w-full text-neutral-900">
                  <div class="flex items-start gap-2 w-full">
                    <input type="checkbox" class="w-5 h-5" aria-label="Exchange option checkbox" />
                    <div class="flex flex-col">
                      <h3 class="text-sm font-bold">
                        Exchange old part for upto ₹2,000 off
                      </h3>
                      <p class="mt-1 text-xs font-medium">
                        The price will be finalised after inspection
                      </p>
                    </div>
                  </div>
                </section>

                <!-- Offers Section -->
                <section
                  class="mt-4 px-4 py-3 rounded-xl w-full bg-white border border-dashed border-gray-300 rounded-lg"
                  *ngIf="availableCoupons && availableCoupons.length > 0">
                  <div class="w-full rounded-lg">
                    <div
                      class="flex justify-between items-center font-bold text-blue-950 text-base relative z-10 custom-before">
                      <h3 class="whitespace-nowrap">Available Offers</h3>
                      <button class="text-sm text-blue-500 whitespace-nowrap" (click)="openCouponPopup()">
                        View all
                      </button>
                    </div>

                    <div class="mt-3 space-y-3">
                      <div *ngFor="
                            let coupon of availableCoupons.slice(0, 2);
                            let isLast = last
                          " [ngClass]="{
                            'pb-2 border-b border-solid border-gray-300':
                              !isLast,
                            'mt-2': !isLast,
                          }" class="flex justify-between items-start w-full gap-2.5">
                        <p class="text-xs font-bold text-black leading-4 w-44">
                          {{ coupon.display_text }}
                          <span class="text-green-700">
                            Save ₹{{ coupon.savings }}</span>
                        </p>
                        <div class="flex items-center gap-0.5 text-sm font-medium text-black">
                          <span>{{ coupon.coupon_code }}</span>
                          <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/1ad82c34a97e416e5e472057a35bc727b9e21da0?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                            class="w-[18px] aspect-square object-contain cursor-pointer" alt="Copy code"
                            (click)="copyToClipboard(coupon.coupon_code)" title="Copy coupon code" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </article>
          </section>
        </div>
        }

        <div *ngIf="(isScrapPart || productDetailData?.part_detail?.part_type === 'Scrap Part') && !isMobile"
          class="-mt-[69px] sm:mt-0">
          <div class="text-sm font-medium leading-none">
            {{ productDetailData?.part_detail?.scrap_category }}
          </div>
          <!-- Price and discount -->
          <div class="flex items-center gap-2 mt-2">
            <p class="text-lg font-semibold">
              ₹{{
              productDetailData?.part_detail?.discounted_taxable
              ? productDetailData?.part_detail?.discounted_taxable
              : productDetailData?.part_detail?.taxable_amount
              }}/<ng-container *ngIf="
                  isOilProductWithLiter(productDetailData?.part_detail);
                  else showKgPrice2
                ">Ltr</ng-container><ng-template #showKgPrice2>Kg</ng-template>
            </p>
            <p class="text-sm line-through text-gray-500"
              *ngIf="productDetailData?.part_detail?.discount_percentage > 0">
              ₹{{ productDetailData?.part_detail?.taxable_amount }}
            </p>
            <span class="text-xs text-white rounded-[16px] bg-[#006C3B] px-2 py-0.5" *ngIf="
                productDetailData?.part_detail?.discount_percentage &&
                productDetailData?.part_detail?.discount_percentage > 0
              ">
              {{ productDetailData?.part_detail?.discount_percentage }}
              %off</span>
          </div>

          <!-- Min & Max Order Qty -->
          <div class="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2">
            <div>
              <span class="text-[#777] text-[14px] font-medium leading-[20px] font-['Uni Neue']">Min Booking Qty
                :</span>
              <span class="text-black text-[14px] font-bold leading-[20px] font-['Uni Neue']">
                <ng-container *ngIf="unit === 'kg'">{{
                  productDetailData?.part_detail?.min_quantity ||
                  productDetailData?.part_detail?.min_qty ||
                  0
                  }}
                  kg</ng-container>
                <ng-container *ngIf="!unit || unit === 'ton'">{{
                  (productDetailData?.part_detail?.min_quantity ||
                  productDetailData?.part_detail?.min_qty ||
                  0) / 1000
                  }}
                  ton</ng-container>
                <ng-container *ngIf="unit === 'liter'">{{
                  productDetailData?.part_detail?.min_quantity ||
                  productDetailData?.part_detail?.min_qty ||
                  0
                  }}
                  ltr</ng-container>
              </span>
            </div>
            <div>
              <span class="text-[#777] text-[14px] font-medium leading-[20px] font-['Uni Neue']">Max Booking Qty
                :</span>
              <span class="text-black text-[14px] font-bold leading-[20px] font-['Uni Neue']">
                <ng-container *ngIf="unit === 'kg'">
                  {{
                  productDetailData?.part_detail?.max_booking_qty ||
                  productDetailData?.part_detail?.max_booking_quantity ||
                  productDetailData?.part_detail?.max_quantity ||
                  productDetailData?.part_detail?.available_quantity ||
                  0
                  }}
                  kg
                </ng-container>
                <ng-container *ngIf="!unit || unit === 'ton'">
                  {{
                  (productDetailData?.part_detail?.max_booking_qty ||
                  productDetailData?.part_detail?.max_booking_quantity ||
                  productDetailData?.part_detail?.max_quantity ||
                  productDetailData?.part_detail?.available_quantity ||
                  0) / 1000
                  }}
                  ton
                </ng-container>
                <ng-container *ngIf="unit === 'liter'">
                  {{
                  productDetailData?.part_detail?.max_booking_qty ||
                  productDetailData?.part_detail?.max_booking_quantity ||
                  productDetailData?.part_detail?.max_quantity ||
                  productDetailData?.part_detail?.available_quantity ||
                  0
                  }}
                  ltr
                </ng-container>
              </span>
            </div>
          </div>

          <!-- Quantity Label -->
          <div class="hidden sm:block text-[#777] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
            Quantity :
          </div>

          <!-- Quantity Input and Selector -->
          <!-- Quantity Input and Selector -->

          <!-- Wrapper for Address + Quantity Buttons -->
          <div class="flex flex-col xl:flex-row xl:items-start gap-2 w-full min-w-0">
            <!-- Address container -->
            <!-- Address container -->
            <div
              class="flex flex-wrap items-center mt-[9px] mr-1 gap-y-2 w-full max-w-[200px] h-10 sm:w-auto sm:h-auto sm:flex-row shrink-0">
              <div
                class="flex w-full max-w-[200px] border border-[#D4D4D4] rounded-[7px] h-10 pl-2 items-center gap-1 shrink-0">
                <!-- Quantity Input -->
                <input type="number" [ngModel]="quantity" (ngModelChange)="onQuantityChange($event)" [min]="minQuantity"
                  [max]="maxQuantity" (blur)="onQuantityInput()"
                  class="text-sm px-1 py-1 w-full sm:w-[70px] border-none focus:outline-none focus:ring-0 text-black font-['Uni Neue'] text-[16px] font-bold leading-[24px]" />

                <!-- divider for desktop -->
                <!-- <div class="hidden sm:block w-px h-[39px] ml-[-6px] bg-[#D4D4D4]"></div> -->

                <!-- Select container with border-left in mobile -->
                <div class="border-l border-l-[1px] border-[#D4D4D4] h-full flex items-center px-1">
                  <select [(ngModel)]="unit" (change)="onUnitChange()"
                    class="text-sm border-none focus:outline-none focus:ring-0 text-center text-black font-['Uni Neue'] font-medium">
                    <option value="ton" *ngIf="
                        !isOilProductWithLiter(productDetailData?.part_detail)
                      ">
                      ton
                    </option>
                    <option value="kg" *ngIf="
                        !isOilProductWithLiter(productDetailData?.part_detail)
                      ">
                      kg
                    </option>
                    <option value="liter" *ngIf="
                        isOilProductWithLiter(productDetailData?.part_detail)
                      ">
                      ltr
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Quick Quantity Buttons -->
            <div class="grid grid-cols-4 gap-2 w-full max-w-full mt-2 sm:flex sm:flex-wrap sm:gap-2">
              <button *ngFor="let qty of quickQuantities" (click)="selectQuantity(qty)" [ngClass]="{
                  'border border-[#307FE1] text-blue-600 sm:bg-[rgba(192,216,246,0.2)]':
                    isQuickQuantitySelected(qty),
                  'border border-gray-300 text-black bg-white':
                    !isQuickQuantitySelected(qty),
                }"
                class="py-2 px-1 min-h-[40px] sm:w-14 lg:w-16 sm:p-2 flex justify-center items-center rounded-lg text-sm font-medium text-center">
                {{ getQuickQuantityDisplay(qty) }} ton
              </button>
            </div>
          </div>

          <!-- Error messages for quantity validation (matching product-list pattern) -->
          <div *ngIf="
              quantityTouched &&
              (isScrapPart ||
                productDetailData?.part_detail?.part_type === 'Scrap Part') &&
              (getSelectedQuantityInKg() === 0 ||
                getSelectedQuantityInKg() === null ||
                getSelectedQuantityInKg() === undefined)
            " class="block text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
            Please select a quantity
          </div>
          <div *ngIf="
              quantityTouched &&
              (isScrapPart ||
                productDetailData?.part_detail?.part_type === 'Scrap Part') &&
              getSelectedQuantityInKg() > 0 &&
              getSelectedQuantityInKg() <
                (productDetailData?.part_detail?.min_quantity ||
                  productDetailData?.part_detail?.min_qty ||
                  0)
            " class="block text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
            Minimum quantity is
            <span *ngIf="unit === 'kg'">{{
              productDetailData?.part_detail?.min_quantity ||
              productDetailData?.part_detail?.min_qty ||
              0
              }}
              kg</span><span *ngIf="unit === 'ton'">{{
              (productDetailData?.part_detail?.min_quantity ||
              productDetailData?.part_detail?.min_qty ||
              0) / 1000
              }}
              ton</span><span *ngIf="unit === 'liter'">{{
              productDetailData?.part_detail?.min_quantity ||
              productDetailData?.part_detail?.min_qty ||
              0
              }}
              ltr</span>
          </div>
          <div *ngIf="
              quantityTouched &&
              (isScrapPart ||
                productDetailData?.part_detail?.part_type === 'Scrap Part') &&
              getSelectedQuantityInKg() > 0 &&
              getSelectedQuantityInKg() >
                (productDetailData?.part_detail?.max_booking_qty ||
                  productDetailData?.part_detail?.max_booking_quantity ||
                  productDetailData?.part_detail?.max_quantity ||
                  productDetailData?.part_detail?.available_quantity ||
                  0)
            " class="block text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
            Maximum available quantity is
            <span *ngIf="unit === 'kg'">{{
              productDetailData?.part_detail?.max_booking_qty ||
              productDetailData?.part_detail?.max_booking_quantity ||
              productDetailData?.part_detail?.max_quantity ||
              productDetailData?.part_detail?.available_quantity ||
              0
              }}
              kg</span><span *ngIf="unit === 'ton'">{{
              (productDetailData?.part_detail?.max_booking_qty ||
              productDetailData?.part_detail?.max_booking_quantity ||
              productDetailData?.part_detail?.max_quantity ||
              productDetailData?.part_detail?.available_quantity ||
              0) / 1000
              }}
              ton</span><span *ngIf="unit === 'liter'">{{
              productDetailData?.part_detail?.max_booking_qty ||
              productDetailData?.part_detail?.max_booking_quantity ||
              productDetailData?.part_detail?.max_quantity ||
              productDetailData?.part_detail?.available_quantity ||
              0
              }}
              ltr</span>
          </div>
        </div>

        <section class="mt-6 w-full">
          <div class="flex gap-10 justify-between items-center w-full text-sm leading-none">
            <div class="flex gap-1 items-center self-stretch my-auto">
              <span class="self-stretch my-auto font-medium text-neutral-500">
                Seller:{{ productDetailData?.seller_detail?.seller_name || productDetailData?.seller_name ||
                productDetailData?.seller_detail?.BRANCH_NAME_s || productDetailData?.seller_detail?.branch_name }}
              </span>
              <span class="self-stretch my-auto font-bold text-blue-950 whitespace-nowrap">
                {{ productDetailData?.seller_detail?.city }},
                {{ productDetailData?.seller_detail?.pincode }}
              </span>
            </div>
            <button (click)="gotoOther()"
              class="flex gap-1 justify-center items-center self-stretch my-auto font-bold text-center text-blue-500 rounded-xl cursor-pointer">
              <span class="gap-2 self-stretch my-auto cursor-pointer">
                View Other
              </span>
            </button>
          </div>

          <div class="mt-3 w-full font-bold">
            <div class="flex gap-10 justify-between border items-center px-2 py-2.5 w-full rounded-lg"
              *ngIf="!isScrapPart">
              <address class="gap-3 self-stretch my-auto text-base text-black not-italic">
                {{
                userLocation?.pincode
                ? userLocation?.pincode
                : productDetailData?.seller_detail?.pincode
                }}
              </address>
              <button
                class="flex gap-1 justify-center items-center self-stretch my-auto text-sm leading-none text-center text-blue-500 whitespace-nowrap rounded-xl">
                <span class="gap-2 self-stretch my-auto"> Change </span>
              </button>
            </div>

            <div class="flex justify-between items-center mt-2 w-full text-base min-h-[25px] text-blue-950">
              <p
                class="flex-1 shrink gap-2 self-stretch my-auto w-full basis-0 min-w-60 text-[#0A0A5F] text-sm font-bold leading-5">
                Store pickup {{ getDeliveryDate() }}
              </p>
            </div>

            <div class="flex gap-2 items-center mt-2 w-full text-sm font-medium leading-none" *ngIf="!isScrapPart">
              <p class="self-stretch my-auto text-neutral-500">
                <span style="color: rgba(0, 0, 0, 1)">Fee </span>
                <span style="color: rgba(0, 0, 0, 1)">₹500</span>
              </p>
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/0ce54d910012140d053aa423afbcd66d078e8de7?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                alt="Divider"
                class="object-contain shrink-0 self-stretch aspect-[0.05] stroke-[1px] stroke-neutral-300" />
              <div class="flex gap-1 items-center self-stretch my-auto text-black cursor-pointer"
                (click)="togglePopup()">
                <span class="self-stretch my-auto cursor-pointer">
                  Open Box Delivery
                </span>
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/1ab48a6b497ae5f32419d449f4e6ee35a62dfb95?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Info icon"
                  class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square cursor-pointer" />
              </div>
            </div>
          </div>
        </section>
        <!-- Benefit icons -->
        <!-- Benefit Icons -->
        <section class="mt-6 w-full text-xs font-medium leading-none text-center min-h-[50px] text-blue-950 relative">
          <!-- Images wrapper with dynamic justify -->
          <div class="flex w-full gap-12" [ngClass]="{ 'gap-10 justify-start': isScrapPart }">
            <!-- Loop through benefits -->
            <div *ngFor="let benefit of getBenefits(); let i = index"
              class="flex flex-col items-center self-stretch my-auto w-[69px] cursor-pointer relative"
              (click)="onBenefitClick($event, i)">
              <img [src]="benefit.icon" [alt]="benefit.text" class="object-contain w-6 aspect-square" />
              <span>{{ benefit.text }}</span>

              <!-- Tooltip-style popup -->
              <div *ngIf="selectedIndex === i" [ngClass]="{
                  'right-0':
                    benefit.text === 'Get Delivered' ||
                    benefit.text === 'Store Pickup',
                  'ml-32':
                    benefit.text !== 'Get Delivered' &&
                    benefit.text !== 'Store Pickup',
                }"
                class="absolute top-full mt-2 z-20 bg-white text-black text-left rounded-lg shadow-lg w-[13rem] p-4">
                <!-- Triangle pointer -->
                <div [ngClass]="{
                    'right-4':
                      benefit.text === 'Get Delivered' ||
                      benefit.text === 'Store Pickup',
                    'left-1/2 -translate-x-1/2':
                      benefit.text !== 'Get Delivered' &&
                      benefit.text !== 'Store Pickup',
                  }"
                  class="absolute -top-2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-white">
                </div>

                <div class="flex items-center border-b border-blue-500 pb-2 mb-2">
                  <img [src]="benefit.icon" class="w-5 h-5 mr-2" />
                  <h2 class="font-bold text-black text-sm">
                    {{ benefit.text }}
                  </h2>
                  <button class="ml-auto text-lg font-bold" (click)="onCloseBenefitClick($event)">
                    ×
                  </button>
                </div>
                <p class="text-sm font-medium">{{ benefit.description }}</p>
              </div>
            </div>
          </div>
        </section>

        <div *ngIf="isScrapPart" class="mt-4">
          <h2 class="text-black text-xl font-bold leading-[28px]">
            Description
          </h2>
          <p class="text-black text-sm font-medium leading-[20px]">
            {{ displayText }}
          </p>
          <div *ngIf="isLongText" class="flex items-center" (click)="toggleSeeMore()">
            <div class="text-blue-600 font-medium mt-2 cursor-pointer">
              <span>
                {{ showMore ? "See Less" : "See More" }}
              </span>
            </div>
            <div class="ml-2 mt-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                [style.transform]="showMore ? 'rotate(180deg)' : 'rotate(0deg)'"
                style="transition: transform 0.3s ease">
                <path d="M5 7.5L9.29289 11.7929C9.68342 12.1834 10.3166 12.1834 10.7071 11.7929L15 7.5" stroke="#307FE1"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Product Specifications and   Donor Vehicle Specifications -->
        <div class="mt-6 w-full font-bold" *ngIf="!isScrapPart">
          <section class="w-full mb-6">
            <header class="flex gap-8 items-center w-full text-xl leading-snug text-black">
              <h2 class="flex-1 shrink self-stretch my-auto basis-0 cursor-pointer" (click)="toggleExpanded()">
                Product Specifications
              </h2>
              <button (click)="toggleExpanded()" [attr.aria-expanded]="expanded" aria-controls="specifications-content"
                class="focus:outline-none">
                <div [class]="
                    expanded
                      ? 'rotate-180 transform transition-transform'
                      : 'transition-transform'
                  ">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="icon" style="width: 24px; height: 24px">
                    <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </button>
            </header>
            <div class="mt-6 w-full" *ngIf="expanded">
              <ng-container *ngFor="let row of productSpecifications; let i = index">
                <div class="mt-3" [class.mt-0]="i === 0">
                  <div class="flex gap-6 justify-between items-center w-full">
                    <div *ngFor="let item of row"
                      class="self-stretch pb-2 my-auto border-b border-solid border-b-[color:var(--Neutrals-Light-Gray,#C0C5C7)]"
                      [class.w-[198px]]="row.indexOf(item) === 0" [class.w-[199px]]="row.indexOf(item) === 1"
                      [class.whitespace-nowrap]="item.label === 'Category'">
                      <div class="text-xs leading-none text-neutral-500">
                        {{ item.label }}
                      </div>
                      <div class="mt-1 text-sm text-black" [class.leading-5]="item.label === 'Dimension'">
                        {{ item.value }}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </section>

          <!-- Donor Vehicle Specifications -->
          <section class="w-full mb-6" *ngIf="!isScrapPart">
            <header class="flex gap-8 items-center w-full text-xl leading-snug text-black">
              <h2 class="flex-1 shrink self-stretch my-auto basis-0 cursor-pointer" (click)="toggleDonorSpecs()">
                Donor Vehicle
              </h2>
              <button (click)="toggleDonorSpecs()" [attr.aria-expanded]="expandedDonorSpecs"
                aria-controls="specifications-content" class="focus:outline-none">
                <div [class]="
                    expandedDonorSpecs
                      ? 'rotate-180 transform transition-transform'
                      : 'transition-transform'
                  ">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="icon" style="width: 24px; height: 24px">
                    <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </button>
            </header>
            <div class="mt-6 w-full" *ngIf="expandedDonorSpecs">
              <ng-container *ngFor="let row of donorVehicleSpecifications; let i = index">
                <div class="mt-3" [class.mt-0]="i === 0">
                  <div class="flex gap-6 justify-between items-center w-full">
                    <div *ngFor="let item of row"
                      class="self-stretch pb-2 my-auto border-b border-solid border-b-[color:var(--Neutrals-Light-Gray,#C0C5C7)]"
                      [class.w-[198px]]="row.indexOf(item) === 0" [class.w-[199px]]="row.indexOf(item) === 1">
                      <div class="text-xs leading-none text-neutral-500">
                        {{ item.label }}
                      </div>
                      <div class="mt-1 text-sm text-black">
                        {{ item.value }}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </section>
        </div>
      </section>
    </div>
    <!-- Right column (sticky on md+, full width on mobile) -->
    @if (!isMobile) {
    <div class="col-span-12 md:col-span-3 rounded-lg md:sticky md:top-16 md:self-start min-w-0">
      <section class="mx-auto w-full">
        <article class="w-full max-h-none md:max-h-[calc(100vh-5rem)] md:overflow-y-auto">
          <!-- View Compatibility -->
          <section
            class="flex flex-col items-start justify-center pl-0 lg:pl-4 w-full text-base font-bold text-blue-500"
            *ngIf="!isScrapPart">
            <div class="flex items-start max-w-full w-full">
              <div class="flex items-center gap-1 rounded-xl min-h-8 w-full">
                <button
                  class="flex items-center gap-2 my-auto cursor-pointer hover:opacity-80 transition-opacity relative z-10"
                  (click)="scrollToCompareSection()" type="button">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/33156f53d14239f34c20fcf3406bdea8b5a10be4?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                    class="w-6 aspect-square object-contain" alt="Compatibility icon" />
                  <span class="cursor-pointer">View compatibility</span>
                </button>
              </div>
            </div>
          </section>

          <!-- Price Section -->
          <div class="flex flex-col items-center justify-center w-full px-2 lg:px-4 sm:pb-0"
            [ngClass]="isScrapPart ? 'pt-0 lg:pt-0' : 'pt-2 lg:pt-4'">
            <div class="w-full" *ngIf="!isScrapPart">
              <div class="flex items-center gap-1 h-7 w-full mt-12">
                <h2 class="text-2xl font-bold text-black whitespace-nowrap">
                  ₹{{
                  productDetailData?.part_detail?.discounted_price
                  ? productDetailData?.part_detail?.discounted_price
                  : productDetailData?.part_detail?.price_s
                  }}
                </h2>
                <div class="flex items-center gap-1.5" *ngIf="
                      productDetailData?.part_detail?.discounted_price &&
                      productDetailData?.part_detail?.discount_percentage &&
                      productDetailData?.part_detail?.discount_percentage > 0
                    ">
                  <p class="text-base font-medium text-neutral-500 line-through">
                    ₹{{ productDetailData?.part_detail?.price_s }}
                  </p>
                  <span class="text-sm font-bold text-white bg-emerald-800 px-1.5 rounded-[40px] min-h-6" *ngIf="
                        productDetailData?.part_detail?.discount_percentage &&
                        productDetailData?.part_detail?.discount_percentage > 0
                      ">{{
                    productDetailData?.part_detail?.discount_percentage
                    }}% Off</span>
                </div>
              </div>
            </div>

            <div *ngIf="isScrapPart" class="w-full">
              <div class="flex justify-between items-center mb-[10px] mt-0 md:mt-0.5">
                <span class="text-[#464646] font-bold text-[18px] leading-[24px]">Base Price</span>
                <p class="text-black font-bold text-base leading-[28px]">
                  ₹{{ getBasePrice() > 0 ? (getBasePrice() | number: "1.2-2") : '0' }}
                </p>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-[#777777] font-medium text-[14px] leading-[20px]">
                  Scrap Booking Amount
                  <span *ngIf="getBookingPercentage()" class="text-xs font-bold text-blue-600 ml-1">
                    ({{ getBookingPercentage() }}%)
                  </span>
                </span>
                <p class="text-black text-sm leading-[20px]">
                  ₹{{ formatPriceBreakup(priceBreakup?.scrap_booking_amount ||
                  productDetailData?.part_detail?.booking_amount) }}
                </p>
              </div>
              <div class="flex items-start gap-2 text-xs leading-[18px] text-[#0A0A5F] mt-[10px]"
                *ngIf="getBalanceAmount() > 0">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"
                  class="mt-[2px] shrink-0">
                  <g clip-path="url(#clip0_2215_27824)">
                    <path
                      d="M8.00073 0.666748C12.0505 0.667144 15.3337 3.95089 15.3337 8.00073C15.3333 12.0502 12.0502 15.3333 8.00073 15.3337C3.95089 15.3337 0.667144 12.0505 0.666748 8.00073C0.666748 3.95064 3.95064 0.666748 8.00073 0.666748ZM8.00073 2.00073C4.68702 2.00073 2.00073 4.68702 2.00073 8.00073C2.00113 11.3141 4.68727 14.0007 8.00073 14.0007C11.3139 14.0003 14.0003 11.3139 14.0007 8.00073C14.0007 4.68727 11.3141 2.00113 8.00073 2.00073ZM8.00073 6.66675C8.36859 6.66714 8.66675 6.96579 8.66675 7.33374V11.3337C8.66653 11.7015 8.36845 12.0003 8.00073 12.0007C7.63268 12.0007 7.33396 11.7017 7.33374 11.3337V7.33374C7.33374 6.96555 7.63254 6.66675 8.00073 6.66675ZM7.99976 3.99976C8.36795 3.99976 8.66675 4.29856 8.66675 4.66675C8.6667 5.0349 8.36792 5.33374 7.99976 5.33374C7.63171 5.33361 7.33378 5.03482 7.33374 4.66675C7.33374 4.29864 7.63168 3.99989 7.99976 3.99976Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2215_27824">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <p class="text-[#0A0A5F] font-medium text-[14px] leading-[20px]">
                  The balance amount of ₹{{ getBalanceAmount() | number: "1.2-2" }} is to be paid at the time of store
                  pickup.
                </p>
              </div>
            </div>
            <div *ngIf="isProductLocked()"
              class="flex items-start gap-2 text-[#E30613] text-[12px] leading-[18px] mt-[10px] -ml-6">
              <!-- <div class="flex items-center gap-2 text-[#E30613] text-[12px] font-bold max-md:text-base"> -->
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16">
                <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />
                <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />
                <circle cx="16" cy="23" r="2" fill="red" />
              </svg>
              <span>This part is no longer available for purchase.</span>
            </div>
            <!-- Exchange Offer -->
            <section *ngIf="!isScrapPart"
              class="flex flex-col items-center justify-center mt-4 p-2 bg-white border border-gray-300 rounded-lg rounded-md w-full text-neutral-900">
              <div class="flex items-start gap-2 w-full">
                <input type="checkbox" class="w-5 h-5" aria-label="Exchange option checkbox" />
                <div class="flex flex-col">
                  <h3 class="text-sm font-bold">
                    Exchange old part for upto ₹2,000 off
                  </h3>
                  <p class="mt-1 text-xs font-medium">
                    The price will be finalised after inspection
                  </p>
                </div>
              </div>
            </section>

            <!-- Action Buttons -->
            <div class="mt-4 text-base font-bold text-center w-full">
              <!-- Animated Cart Button -->
              <button *ngIf="!isScrapPart" [disabled]="isProductLocked()"
                class="cart-btn flex items-center justify-center gap-1 p-2 w-full whitespace-nowrap bg-blue-500 rounded-lg min-h-10"
                [class.added]="itemAddedToCart" [class.disabled]="isProductLocked()" (click)="
                    itemAddedToCart
                      ? goToCart()
                      : addToCart(productDetailData?.part_detail?.inventory_id)
                  ">
                <div class="cart-content cart-content-add">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"
                    class="cart-icon-svg">
                    <rect width="20" height="20" transform="translate(0.5)" fill="none" />
                    <path
                      d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
                      fill="white" />
                  </svg>
                  <span class="btn-text text-base font-bold text-white">Add to Cart</span>
                </div>
                <div class="cart-content cart-content-go">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    class="cart-icon-svg w-5 h-5">
                    <path
                      d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                      fill="white" />
                  </svg>
                  <span class="btn-text text-base font-bold text-white">Go to Cart</span>
                </div>
              </button>

              <!-- Animated Cart Button for scrap parts -->
              <button *ngIf="isScrapPart" [disabled]="isProductLocked()"
                class="cart-btn flex items-center justify-center gap-1 p-2 w-full whitespace-nowrap bg-blue-500 rounded-lg min-h-10"
                [class.added]="itemAddedToCart" [class.disabled]="isProductLocked()" (click)="
                    itemAddedToCart
                      ? goToCart()
                      : addToCart(productDetailData?.part_detail?.inventory_id)
                  ">
                <div class="cart-content cart-content-add">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"
                    class="cart-icon-svg">
                    <rect width="20" height="20" transform="translate(0.5)" fill="none" />
                    <path
                      d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
                      fill="white" />
                  </svg>
                  <span class="btn-text text-base font-bold text-white">Add to Cart</span>
                </div>
                <div class="cart-content cart-content-go">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    class="cart-icon-svg w-5 h-5">
                    <path
                      d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                      fill="white" />
                  </svg>
                  <span class="btn-text text-base font-bold text-white">Go to Cart</span>
                </div>
              </button>

              <button [disabled]="isProductLocked()" [ngClass]="{ 'animate-cta': isBuyNowAnimating }"
                (click)="onBuyNowClick()"
                class="flex items-center justify-center gap-1 p-2 mt-3 w-full text-blue-500 border border-blue-500 rounded-lg min-h-10">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/e1d0ce3367710415ccc725fba6749afd03dcdc64?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  class="w-5 aspect-square object-contain" alt="Buy now icon" />
                <span>{{ isScrapPart ? "Book Now" : "Buy Now" }}</span>
              </button>
            </div>
          </div>
          <section class="m-4 p-4 rounded-xl w-90 bg-white border border-dashed border-gray-300 rounded-lg"
            *ngIf="availableCoupons && availableCoupons.length > 0">
            <div class="w-full rounded-lg">
              <div
                class="flex justify-between items-center font-bold text-blue-950 text-base relative z-10 custom-before">
                <h3 class="whitespace-nowrap">Available Offers</h3>
                <button class="text-sm text-blue-500 whitespace-nowrap" (click)="openCouponPopup()">
                  View all
                </button>
              </div>

              <div class="mt-3 space-y-3">
                <div *ngFor="
                      let coupon of availableCoupons.slice(0, 2);
                      let isLast = last
                    " [ngClass]="{
                      'pb-2 border-b border-solid border-gray-300': !isLast,
                      'mt-2': !isLast,
                    }" class="flex justify-between items-start w-full">
                  <p class="text-xs font-bold text-black leading-4">
                    {{ coupon.display_text }}
                    <span class="text-green-700">
                      Save ₹{{ coupon.savings }}</span>
                  </p>
                  <div class="flex items-center gap-0.5 text-sm font-medium text-black">
                    <span>{{ coupon.coupon_code }}</span>
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/1ad82c34a97e416e5e472057a35bc727b9e21da0?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                      class="w-[18px] aspect-square object-contain cursor-pointer" alt="Copy code"
                      (click)="copyToClipboard(coupon.coupon_code)" title="Copy coupon code" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </section>
    </div>
    }
  </div>
</div>
<!-- <div class="widget-menu1" (click)="openPartRequestForm()" *ngIf="!isMobile">
  <span class="ml-2 text-[#0A0A5F] text-base font-bold">Enquire Now</span>
</div> -->
<!-- <div id="compare-section" *ngIf="!isScrapPart">
  <app-compare></app-compare>
</div> -->
<div class="w-full bg-white" appDeferLoad (appDeferLoad)="showPartsForYouSection = true">
  <app-partsforyou *ngIf="showPartsForYouSection" class="w-full block" [chasisNumber]="chasisNumber"
    [partType]="isScrapPart"></app-partsforyou>
</div>
<!-- <app-recently-viewed-parts></app-recently-viewed-parts> -->
<div class="w-full bg-white" appDeferLoad (appDeferLoad)="showSimilarProductsSection = true">
  <app-similar-product *ngIf="showSimilarProductsSection" class="w-full block" [vcNumber]="vcNumber"
    [partType]="isScrapPart"></app-similar-product>
</div>

<div class="fixed top-0 right-0 h-full z-50 transition-transform ease-in-out duration-300 transform"
  [class.invisible]="!isFormOpen"
  [class.pointer-events-none]="!isFormOpen"
  [class.translate-x-full]="!isFormOpen" [class.translate-x-0]="isFormOpen">
  <section class="flex overflow-hidden flex-col justify-between bg-white h-full shadow-xl w-full max-w-[484px]">
    <!-- Header -->
    <header
      class="flex flex-col justify-center px-8 py-5 w-full bg-white border-b border-solid border-b-[#D4D4D4] max-md:px-5">
      <div class="flex gap-10 justify-between items-center w-full">
        <div class="flex gap-3 items-center self-stretch my-auto w-[161px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="96" height="32" viewBox="0 0 96 32" fill="none">
            <g clip-path="url(#clip0_11133_5192)">
              <mask id="mask0_11133_5192" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="-9" y="-41"
                width="113" height="113">
                <path d="M-8.80005 -40.9603H103.84V71.6797H-8.80005V-40.9603Z" fill="white" />
              </mask>
              <g mask="url(#mask0_11133_5192)">
                <path
                  d="M30.8984 26.5971V27.2533H31.2302C31.4884 27.2533 31.6002 27.1523 31.6002 26.9254C31.6002 26.702 31.4884 26.5971 31.2302 26.5971H30.8984ZM31.6771 28.5769L31.607 28.5348L31.1219 27.7424H30.8984V28.5138C30.8984 28.5558 30.8774 28.5769 30.8357 28.5769H30.3991C30.3574 28.5769 30.3363 28.5558 30.3363 28.5138V26.1433C30.3363 26.1012 30.3574 26.0806 30.3991 26.0806H31.2474C31.8413 26.0806 32.176 26.405 32.176 26.922C32.176 27.2847 31.9946 27.5399 31.6737 27.6586L32.2318 28.5034C32.2563 28.5451 32.2392 28.5769 32.1902 28.5769H31.6771Z"
                  fill="#3C3F7F" />
                <path
                  d="M34.1231 28.0703H35.16L35.2228 28.1296V28.5138C35.2228 28.5555 35.1983 28.5765 35.16 28.5765H33.6238C33.5821 28.5765 33.5611 28.5555 33.5611 28.5138V26.143C33.5611 26.1013 33.5821 26.0803 33.6238 26.0803H35.1042C35.1459 26.0803 35.167 26.1013 35.167 26.143V26.5272C35.167 26.5654 35.1459 26.5865 35.1042 26.5865H34.1231V27.0647H34.9891C35.0307 27.0647 35.0518 27.0858 35.0518 27.124V27.5014C35.0518 27.5396 35.0307 27.5607 34.9891 27.5607H34.1231V28.0703Z"
                  fill="#3C3F7F" />
                <path
                  d="M37.4911 28.6144C36.978 28.6144 36.5727 28.3247 36.5727 27.7519V26.907C36.5727 26.3312 36.9814 26.0412 37.4842 26.0412C37.7459 26.0412 38.0115 26.1249 38.2276 26.2857L38.2345 26.3381L38.1227 26.5023L38.0634 26.5091C37.8924 26.3832 37.6797 26.3205 37.4807 26.3205C37.0862 26.3205 36.8697 26.5508 36.8697 26.907V27.7485C36.8697 28.1047 37.0897 28.335 37.4842 28.335C37.7111 28.335 37.9414 28.262 38.1266 28.1185L38.1786 28.1292L38.2938 28.2895L38.2835 28.3492C38.06 28.534 37.7704 28.6144 37.4911 28.6144Z"
                  fill="#3C3F7F" />
                <path
                  d="M40.2519 28.5769L40.2136 28.5387V27.6272L39.3928 26.1296L39.4207 26.0806H39.6722L39.7177 26.1085L40.3636 27.3548L41.006 26.1085L41.0511 26.0806H41.3026L41.3305 26.1296L40.5136 27.6345V28.5387L40.4719 28.5769H40.2519Z"
                  fill="#3C3F7F" />
                <path
                  d="M43.4281 28.6144C42.915 28.6144 42.5097 28.3247 42.5097 27.7519V26.907C42.5097 26.3312 42.9185 26.0412 43.4212 26.0412C43.6829 26.0412 43.9481 26.1249 44.1646 26.2857L44.1715 26.3381L44.0598 26.5023L44.0005 26.5091C43.8295 26.3832 43.6168 26.3205 43.4178 26.3205C43.0233 26.3205 42.8067 26.5508 42.8067 26.907V27.7485C42.8067 28.1047 43.0267 28.335 43.4212 28.335C43.6481 28.335 43.8784 28.262 44.0632 28.1185L44.1157 28.1292L44.2308 28.2895L44.2205 28.3492C43.997 28.534 43.7074 28.6144 43.4281 28.6144Z"
                  fill="#3C3F7F" />
                <path
                  d="M45.6615 28.5769L45.6199 28.5387V26.1193L45.6615 26.0806H45.8816L45.9198 26.1193V28.3045H47.016L47.0547 28.3431V28.5387L47.016 28.5769H45.6615Z"
                  fill="#3C3F7F" />
                <path
                  d="M48.6839 28.3045H49.885L49.9233 28.3428V28.5383L49.885 28.577H48.4256L48.3836 28.5383V26.1189L48.4256 26.0807H49.836L49.8743 26.1189V26.3145L49.836 26.3527H48.6839V27.1696H49.7557L49.7939 27.2117V27.4038L49.7557 27.4455H48.6839V28.3045Z"
                  fill="#3C3F7F" />
                <path
                  d="M53.2459 28.5942C53.1308 28.5942 53.0538 28.5138 53.0538 28.4021C53.0538 28.2869 53.1308 28.2066 53.2459 28.2066C53.3577 28.2066 53.438 28.2869 53.438 28.4021C53.438 28.5138 53.3577 28.5942 53.2459 28.5942Z"
                  fill="#3C3F7F" />
                <path
                  d="M57.1488 28.5769L57.0792 28.5245L56.4191 26.1506C56.4053 26.1085 56.426 26.0806 56.4715 26.0806H56.936L57.0022 26.1364L57.1939 26.9323C57.2502 27.1665 57.3443 27.6306 57.3899 27.9242H57.4036C57.456 27.6237 57.5536 27.2082 57.6305 26.9186L57.8329 26.1678L57.9029 26.1154H58.367L58.4336 26.1678L58.6429 26.9186C58.7164 27.2048 58.8105 27.6237 58.863 27.9242H58.8767C58.9257 27.6306 59.0198 27.1665 59.0757 26.9323L59.2643 26.1364L59.3309 26.0806H59.7984C59.8406 26.0806 59.8647 26.1085 59.8509 26.1506L59.1913 28.5245L59.1212 28.5769H58.6219L58.5523 28.5245L58.3253 27.7252C58.2519 27.4562 58.1715 27.0479 58.1402 26.8206H58.1264C58.0985 27.0479 58.0181 27.4562 57.9446 27.7252L57.7177 28.5245L57.6481 28.5769H57.1488Z"
                  fill="#3C3F7F" />
                <path
                  d="M61.6716 28.5138C61.6716 28.5555 61.6506 28.5765 61.6089 28.5765H61.1723C61.1306 28.5765 61.1096 28.5555 61.1096 28.5138V26.143C61.1096 26.1013 61.1306 26.0802 61.1723 26.0802H61.6089C61.6506 26.0802 61.6716 26.1013 61.6716 26.143V28.5138Z"
                  fill="#3C3F7F" />
                <path
                  d="M64.7819 26.0806L64.8236 26.1188V26.3144L64.7819 26.353H64.035V28.5382L63.9929 28.5769H63.7764L63.7346 28.5382V26.353H62.9874L62.9491 26.3144V26.1188L62.9874 26.0806H64.7819Z"
                  fill="#3C3F7F" />
                <path
                  d="M67.6156 26.1189L67.6573 26.0807H67.8739L67.9126 26.1189V28.5383L67.8739 28.5765H67.6573L67.6156 28.5383V27.4455H66.4497V28.5383L66.4111 28.5765H66.1949L66.1528 28.5383V26.1189L66.1949 26.0807H66.4111L66.4497 26.1189V27.173H67.6156V26.1189Z"
                  fill="#3C3F7F" />
                <path
                  d="M71.252 28.5942C71.1369 28.5942 71.0599 28.5138 71.0599 28.4021C71.0599 28.2869 71.1369 28.2066 71.252 28.2066C71.3638 28.2066 71.4442 28.2869 71.4442 28.4021C71.4442 28.5138 71.3638 28.5942 71.252 28.5942Z"
                  fill="#3C3F7F" />
                <path
                  d="M75.221 26.5971V27.2533H75.5528C75.811 27.2533 75.9227 27.1523 75.9227 26.9254C75.9227 26.702 75.811 26.5971 75.5528 26.5971H75.221ZM75.9997 28.5769L75.9296 28.5348L75.4445 27.7424H75.221V28.5138C75.221 28.5558 75.1999 28.5769 75.1582 28.5769H74.7216C74.68 28.5769 74.6589 28.5558 74.6589 28.5138V26.1433C74.6589 26.1012 74.68 26.0806 74.7216 26.0806H75.5703C76.1638 26.0806 76.4985 26.405 76.4985 26.922C76.4985 27.2847 76.3172 27.5399 75.9962 27.6586L76.5544 28.5034C76.5789 28.5451 76.5617 28.5769 76.5127 28.5769H75.9997Z"
                  fill="#3C3F7F" />
                <path
                  d="M78.4459 28.0703H79.4828L79.5456 28.1296V28.5138C79.5456 28.5555 79.5211 28.5765 79.4828 28.5765H77.9466C77.9049 28.5765 77.8839 28.5555 77.8839 28.5138V26.143C77.8839 26.1013 77.9049 26.0803 77.9466 26.0803H79.427C79.4687 26.0803 79.4897 26.1013 79.4897 26.143V26.5272C79.4897 26.5654 79.4687 26.5865 79.427 26.5865H78.4459V27.0647H79.3119C79.3535 27.0647 79.3746 27.0858 79.3746 27.124V27.5014C79.3746 27.5396 79.3535 27.5607 79.3119 27.5607H78.4459V28.0703Z"
                  fill="#3C3F7F" />
                <path
                  d="M81.7235 28.6144C81.378 28.6144 81.1267 28.5061 80.8508 28.2827L80.8439 28.2268L80.9625 28.0626L81.0149 28.0523C81.2556 28.2337 81.4721 28.3282 81.7338 28.3316C82.0518 28.3316 82.338 28.1989 82.338 27.9058C82.338 27.6161 82.0832 27.525 81.6853 27.4378C81.2624 27.3437 80.8508 27.1653 80.8508 26.7012C80.8508 26.2401 81.2624 26.0412 81.7412 26.0412C82.0518 26.0412 82.2891 26.1284 82.5542 26.3205L82.565 26.3729L82.4498 26.5371L82.3939 26.5439C82.1807 26.3974 81.9573 26.3239 81.7167 26.317C81.3849 26.317 81.1512 26.4533 81.1512 26.7081C81.1512 26.9733 81.3953 27.0678 81.7618 27.1516C82.2263 27.2564 82.638 27.403 82.638 27.8989C82.638 28.3978 82.2156 28.6144 81.7235 28.6144Z"
                  fill="#3C3F7F" />
                <path
                  d="M84.9204 27.442C85.3218 27.442 85.5173 27.2606 85.5173 26.8975C85.5173 26.5378 85.3218 26.3561 84.9204 26.3561H84.3686V27.442H84.9204ZM84.9517 26.0806C85.5035 26.0806 85.8177 26.3879 85.8177 26.8975C85.8177 27.4141 85.5001 27.7179 84.9517 27.7179H84.3686V28.5383L84.3304 28.5769H84.1103L84.0721 28.5383V26.1189L84.1103 26.0806H84.9517Z"
                  fill="#3C3F7F" />
                <path
                  d="M87.5308 28.3045H88.7318L88.7701 28.3428V28.5383L88.7318 28.577H87.2725L87.2304 28.5383V26.1189L87.2725 26.0807H88.6828L88.7211 26.1189V26.3145L88.6828 26.3527H87.5308V27.1696H88.6025L88.6408 27.2117V27.4038L88.6025 27.4455H87.5308V28.3045Z"
                  fill="#3C3F7F" />
                <path
                  d="M91.0318 28.6144C90.5188 28.6144 90.1135 28.3247 90.1135 27.7519V26.907C90.1135 26.3312 90.5222 26.0412 91.025 26.0412C91.2867 26.0412 91.5522 26.1249 91.7684 26.2857L91.7753 26.3381L91.6635 26.5023L91.6047 26.5091C91.4332 26.3832 91.2205 26.3205 91.0215 26.3205C90.6271 26.3205 90.4105 26.5508 90.4105 26.907V27.7485C90.4105 28.1047 90.6304 28.335 91.025 28.335C91.2518 28.335 91.4822 28.262 91.6674 28.1185L91.7194 28.1292L91.835 28.2895L91.8243 28.3492C91.6008 28.534 91.3111 28.6144 91.0318 28.6144Z"
                  fill="#3C3F7F" />
                <path
                  d="M94.787 26.0806L94.8292 26.1188V26.3144L94.787 26.353H94.0402V28.5382L93.9981 28.5769H93.7819L93.7398 28.5382V26.353H92.9925L92.9542 26.3144V26.1188L92.9925 26.0806H94.787Z"
                  fill="#3C3F7F" />
                <path
                  d="M20.5714 1.1261L19.5473 3.80113C19.5473 3.80113 15.6312 1.98341 10.1672 4.47669C6.05425 6.30906 4.3624 10.7125 4.3624 10.7125L5.70231 11.0357L1.96626 14.0876L0.210825 9.71079L1.55929 10.0361C1.55929 10.0361 2.87943 5.11316 8.79422 1.95592C14.7086 -1.20132 20.5714 1.1261 20.5714 1.1261Z"
                  fill="#3C3F7F" />
                <path
                  d="M18.4296 13.8714C18.4296 14.1219 18.2306 14.3252 17.9852 14.3252H13.5753V11.5418H17.9852C18.2306 11.5418 18.4296 11.7451 18.4296 11.9956V13.8714ZM37.2354 19.0432H30.196C30.3902 18.3165 30.532 17.5499 30.6012 16.748H36.2251C39.1679 16.748 39.1679 13.8374 39.1679 13.8374H30.5574C30.4719 13.012 30.3301 12.2475 30.1522 11.5418H37.2354C40.6513 11.5418 40.6513 8.37001 40.6513 8.37001H28.9678C27.9945 6.4633 26.9597 5.48823 26.9597 5.48823L27.8853 4.4547L23.1991 3.92743L24.1175 8.66395L25.0367 7.63689C25.0367 7.63689 28.1135 11.2123 27.7792 15.7029C27.5764 18.7991 26.3933 21.1476 25.2962 22.6968L20.0015 17.4868C20.0015 17.4868 21.7638 17.4868 21.7638 15.1421V10.4894C21.7638 8.39147 20.0015 8.37001 20.0015 8.37001H9.73955V18.7789C9.73955 22.5722 13.519 22.5722 13.519 22.5722V17.4868H15.9397L23.3186 24.8974L25.3121 26.9438C25.3121 26.9438 27.3795 25.1738 28.9407 22.2155H40.6513C40.6513 22.2155 40.6513 19.0432 37.2354 19.0432Z"
                  fill="#3C3F7F" />
                <path
                  d="M59.6056 8.41341C58.4888 8.43921 57.4686 9.04899 56.9181 10.0167C56.6246 10.5332 56.4011 11.0902 56.2563 11.6725L54.9022 16.9676L53.3711 10.7821H51.8168H50.2624L48.7313 16.9676L47.3773 11.6725C47.2329 11.0902 47.0094 10.5332 46.7155 10.0167C46.165 9.04899 45.1448 8.43921 44.0279 8.41341L43.1087 8.39196L46.712 22.0874H50.5371L51.8168 17.0806L53.0965 22.0874H56.922L60.5248 8.39196L59.6056 8.41341Z"
                  fill="#3C3F7F" />
                <path
                  d="M64.9909 22.1785H63.0202C62.0666 22.1785 61.2935 21.4054 61.2935 20.4519V8.3915H63.2643C64.2178 8.3915 64.9909 9.16461 64.9909 10.1186V22.1785Z"
                  fill="#3C3F7F" />
                <path
                  d="M78.8454 13.7179C78.8454 13.9615 78.6511 14.1588 78.4113 14.1588H74.1063V11.4532H78.4113C78.6511 11.4532 78.8454 11.6505 78.8454 11.8941V13.7179ZM83.5157 22.1793L80.3799 17.2331C80.3799 17.2331 82.101 17.2331 82.101 14.9533V10.4296C82.101 8.39004 80.3799 8.36898 80.3799 8.36898H70.3612V18.4892C70.3612 22.1771 74.0513 22.1771 74.0513 22.1771V17.2331H76.4144L78.3693 20.1999C79.1814 21.4319 80.5613 22.1754 82.0417 22.1771L83.5157 22.1793Z"
                  fill="#3C3F7F" />
                <path
                  d="M91.0593 19.0246H87.2661C86.9931 19.0246 86.7719 18.8033 86.7719 18.5304V17.2172C86.7719 16.9477 86.9902 16.729 87.2596 16.729H90.0494C92.9922 16.729 92.9922 13.8189 92.9922 13.8189H87.2674C86.9936 13.8189 86.7719 13.5971 86.7719 13.3234V12.0188C86.7719 11.745 86.9936 11.5232 87.2674 11.5232H91.0593C94.4752 11.5232 94.4752 8.35142 94.4752 8.35142H86.7719H86.1075C84.5158 8.35142 83.2257 9.64148 83.2257 11.2327V19.3151C83.2257 20.9064 84.5158 22.1969 86.1075 22.1969H86.7719H94.4752C94.4752 22.1969 94.4752 19.0246 91.0593 19.0246Z"
                  fill="#3C3F7F" />
                <path
                  d="M42.8885 15.3954C42.8885 15.9308 42.4545 16.3649 41.919 16.3649C41.3836 16.3649 40.9496 15.9308 40.9496 15.3954C40.9496 14.8599 41.3836 14.4259 41.919 14.4259C42.4545 14.4259 42.8885 14.8599 42.8885 15.3954Z"
                  fill="#3C3F7F" />
                <path
                  d="M68.6538 15.3954C68.6538 15.9308 68.2198 16.3649 67.6843 16.3649C67.1489 16.3649 66.7149 15.9308 66.7149 15.3954C66.7149 14.8599 67.1489 14.4259 67.6843 14.4259C68.2198 14.4259 68.6538 14.8599 68.6538 15.3954Z"
                  fill="#3C3F7F" />
                <path
                  d="M0.499624 17.6959L3.32897 17.2524C3.32897 17.2524 3.70198 21.554 8.58414 25.052C12.2209 27.7077 16.8818 26.9832 16.8818 26.9832L16.495 25.6601L21.0016 27.3816L18.0795 31.0824L17.6905 29.751C17.6905 29.751 12.7637 31.0566 7.08135 27.498C1.39905 23.9394 0.499624 17.6959 0.499624 17.6959Z"
                  fill="#3C3F7F" />
                <path
                  d="M76.3195 6.06918V0.706559H78.1416V-0.260343H73.3613V0.706559H75.1649V6.06918H76.3195ZM70.1027 0.565646C71.2582 0.565646 71.8499 1.69278 71.8499 2.8853C71.8499 4.20972 71.2204 5.24235 70.1027 5.24235C68.9948 5.24235 68.3468 4.21918 68.3468 2.93216C68.3468 1.6266 68.957 0.565646 70.1027 0.565646ZM70.0369 6.1723C71.7838 6.1723 73.0703 4.96092 73.0703 2.83889C73.0703 1.0353 71.981 -0.363859 70.131 -0.363859C68.3468 -0.363859 67.1259 1.00697 67.1259 2.95108C67.1259 4.81048 68.2527 6.1723 70.0369 6.1723ZM87.3447 2.62234H86.6597V0.62191C86.7719 0.593976 87.0069 0.565646 87.3726 0.565646C88.1242 0.565646 88.6129 0.884925 88.6129 1.5798C88.6129 2.20935 88.1242 2.62234 87.3447 2.62234ZM89.9931 6.06918C89.8616 5.82509 89.6923 5.09242 89.4955 4.30344C89.3356 3.69276 89.0636 3.25189 88.6129 3.08253V3.0542C89.2042 2.83844 89.7585 2.28414 89.7585 1.46722C89.7585 0.932177 89.5612 0.490854 89.2136 0.19906C88.7907 -0.157615 88.1711 -0.308046 87.2604 -0.308046C86.5936 -0.308046 85.9455 -0.251275 85.5136 -0.176538V6.06918H86.6597V3.46759H87.2416C87.899 3.48606 88.1994 3.74947 88.3773 4.57586C88.5561 5.36439 88.7061 5.88096 88.8006 6.06918H89.9931ZM64.7873 0.82821H64.8157C64.8062 1.68337 64.8535 2.66914 64.8909 3.48606L65.0129 6.06918H66.1396L65.7736 -0.260737H64.2712L63.3975 2.27468C63.1535 3.01635 62.9377 3.79678 62.7684 4.48174H62.7401C62.5806 3.77786 62.3834 3.02587 62.1582 2.28414L61.3314 -0.260737H59.8102L59.3878 6.06918H60.4677L60.6082 3.52391C60.6555 2.66013 60.6933 1.65499 60.7212 0.82821H60.7397C60.909 1.6172 61.1342 2.48137 61.3787 3.28928L62.224 5.99354H63.1161L64.0362 3.25189C64.318 2.45299 64.5806 1.59827 64.7873 0.82821ZM81.4097 5.24235C80.3014 5.24235 79.6538 4.21918 79.6538 2.93216C79.6538 1.6266 80.264 0.565646 81.4097 0.565646C82.5648 0.565646 83.1561 1.69278 83.1561 2.8853C83.1561 4.20972 82.527 5.24235 81.4097 5.24235ZM81.4376 -0.363859C79.6538 -0.363859 78.4325 1.00697 78.4325 2.95108C78.4325 4.81048 79.5597 6.1723 81.344 6.1723C83.0908 6.1723 84.377 4.96092 84.377 2.83889C84.377 1.0353 83.288 -0.363859 81.4376 -0.363859ZM47.2577 6.07048V1.61804H49.002V-0.259892H42.8935V1.61804H44.7164V6.07048H47.2577ZM41.0198 -0.259892H38.3761L35.9898 6.07048H38.4277L39.7113 2.31506L41.0198 6.07048H43.4839L41.0198 -0.259892ZM92.5002 5.21402C91.9089 5.21402 91.3455 5.02664 90.9694 4.81048L90.716 5.76883C91.0636 5.97507 91.7584 6.16284 92.425 6.16284C94.0592 6.16284 94.8289 5.28019 94.8289 4.26559C94.8289 3.35456 94.2938 2.80065 93.1954 2.38726C92.3497 2.05897 91.9841 1.83335 91.9841 1.34517C91.9841 0.978585 92.3029 0.584514 93.0356 0.584514C93.6274 0.584514 94.0687 0.762879 94.2938 0.884924L94.5758 -0.0450311C94.247 -0.213878 93.7399 -0.363859 93.0545 -0.363859C91.6833 -0.363859 90.8195 0.424678 90.8195 1.45776C90.8195 2.36834 91.4856 2.92315 92.5281 3.29869C93.3364 3.58964 93.6553 3.87152 93.6553 4.35024C93.6553 4.8672 93.2423 5.21402 92.5002 5.21402ZM32.3195 6.07048H34.8613V1.61804H36.6314V-0.259892H30.5237V1.61804H32.3195V6.07048ZM53.3904 -0.259892H50.7467L48.3604 6.07048H50.7979L52.0823 2.31506L53.3904 6.07048H55.8532L53.3904 -0.259892Z"
                  fill="#3C3F7F" />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_11133_5192">
                <rect width="96" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <!-- <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/0ac75e346c7eae3ef3cbcc5ed50de5783aa6a535"
            class="object-contain self-stretch my-auto w-40 aspect-[6.67]"
            alt="Tata Motors"
          /> -->
        </div>
        <!-- <p
          class="flex gap-0 items-center self-stretch my-auto text-sm tracking-widest font-[350] text-blue-950"
        >
          <span class="self-stretch my-auto">CIRCULARITY</span>
        </p> -->
        <!-- <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/60469587d3963694237e3660455ab7f16fee3765"
          class="object-contain shrink-0 self-stretch my-auto w-9 aspect-[1.5]"
          alt="Tata logo"
        /> -->
      </div>
    </header>

    <!-- Main content -->
    <main class="flex-1 overflow-y-auto px-8 py-6 w-full max-md:px-5">
      <!-- Title and close button -->
      <header class="flex gap-10 justify-between items-start w-full text-2xl font-bold leading-none text-blue-950">
        <h2 class="min-w-60">Can't find what you need?</h2>
        <button (click)="closePartRequestForm()">
          <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/662d7f6331c6e3e7c764af94565ee76ed2d22565"
            class="object-contain shrink-0 w-8 aspect-square" alt="Close" />
        </button>
      </header>

      <!-- Form fields -->
      <form [formGroup]="partForm">
        <!-- Part Name -->
        <div class="mt-4 w-full">
          <label class="block w-full text-sm font-bold leading-none text-zinc-700 mb-1">
            Part Name
          </label>
          <div class="flex gap-2 items-center px-3 py-3 w-full text-base font-medium rounded-lg border border-gray-200"
            [ngStyle]="{
              border:
                partForm.get('partName')?.invalid &&
                partForm.get('partName')?.touched
                  ? '2px solid red'
                  : '1px solid #ccc',
            }">
            <input formControlName="partName" placeholder="Enter part name you are looking for"
              class="w-full outline-none text-neutral-500" (keypress)="alphaNumberOnly($event)"
              (keydown)="preventLeadingSpace($event, $event.target)" />
          </div>
          <div class="text-red-500 text-sm mt-1" *ngIf="
              partForm.get('partName')?.touched &&
              partForm.get('partName')?.invalid
            ">
            <div *ngIf="partForm.get('partName')?.errors?.['required']">
              Part name is required.
            </div>
          </div>
        </div>

        <!-- Brand and Vehicle Model -->
        <div class="flex gap-4 items-start mt-4 w-full">
          <div class="flex-1">
            <label class="block w-full text-sm font-bold leading-none text-zinc-700 mb-1">
              Brand
            </label>
            <div class="relative">
              <select formControlName="brand" (change)="onBrandSelect($event)"
                class="appearance-none w-full px-3 py-3 text-base font-sm bg-white rounded-lg border border-gray-200 text-neutral-500">
                <div class="text-red-500 text-sm mt-1" *ngIf="
                    partForm.get('brand')?.touched &&
                    partForm.get('brand')?.invalid
                  ">
                  <div *ngIf="partForm.get('brand')?.errors?.['required']">
                    Brand is required.
                  </div>
                </div>
                <option value="" disabled selected>Select Brand</option>
                <option *ngFor="let b of brands" [value]="b.VEHICLE_MAKE_s">
                  {{ b?.VEHICLE_MAKE_s }}
                </option>
                <!-- <option value="tata">Tata</option>
                <option value="other">Other</option> -->
              </select>
            </div>
          </div>

          <div class="flex-1">
            <label class="block w-full text-sm font-bold leading-none text-zinc-700 mb-1">
              Vehicle Model
            </label>
            <div class="relative">
              <select formControlName="vehicleModel" (change)="onModelSelect($event)"
                class="appearance-none w-full px-2 py-3 text-base font-sm bg-white rounded-lg border border-gray-200 text-neutral-500">
                <div class="text-red-500 text-sm mt-1" *ngIf="
                    partForm.get('vehicleModel')?.touched &&
                    partForm.get('vehicleModel')?.invalid
                  ">
                  <div *ngIf="partForm.get('vehicleModel')?.errors?.['required']">
                    Vehicle Model is required.
                  </div>
                </div>
                <option value="" disabled selected>Select Vehicle Model</option>
                <option *ngFor="let model of modelList" [value]="model.model_name">
                  {{ model?.model_name }}
                </option>
                <!-- <option value="model1">Model 1</option>
                <option value="model2">Model 2</option> -->
              </select>
            </div>
          </div>
        </div>

        <!-- Year and Category -->
        <div class="flex gap-4 items-start mt-4 w-full">
          <div class="flex-1">
            <label class="block w-full text-sm font-bold leading-none text-zinc-700 mb-1">
              Year of Manufacturing
            </label>
            <div class="relative">
              <select formControlName="year" (change)="onYearSelect($event)"
                class="appearance-none w-full px-3 py-3 text-base font-sm bg-white rounded-lg border border-gray-200 text-neutral-500">
                <div class="text-red-500 text-sm mt-1" *ngIf="
                    partForm.get('year')?.touched &&
                    partForm.get('year')?.invalid
                  ">
                  <div *ngIf="partForm.get('year')?.errors?.['required']">
                    Year is required.
                  </div>
                </div>

                <option value="" disabled selected>Select Year</option>
                <option *ngFor="let year of yearList" [value]="year">
                  {{ year }}
                </option>
                <!-- <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option> -->
              </select>
            </div>
          </div>

          <div class="flex-1">
            <label class="block w-full text-sm font-bold leading-none text-zinc-700 mb-1">
              Category
            </label>
            <div class="relative">
              <select formControlName="category"
                class="appearance-none w-full px-3 py-3 text-base font-sm bg-white rounded-lg border border-gray-200 text-neutral-500"
                (click)="onCategorySelect($event)">
                <div class="text-red-500 text-sm mt-1" *ngIf="
                    partForm.get('category')?.touched &&
                    partForm.get('category')?.invalid
                  ">
                  <div *ngIf="partForm.get('category')?.errors?.['required']">
                    Category is required.
                  </div>
                </div>
                <option value="" disabled selected>Select Category</option>
                <option *ngFor="let category of categoryList" [value]="category.category_name">
                  {{ category?.category_name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Attachment -->
        <div class="mt-4 w-full">
          <label class="block w-full text-sm font-bold leading-none text-zinc-700 mb-1">
            Attachment
          </label>
          <div class="flex gap-2 items-center p-2 w-full text-base bg-white rounded-lg border border-gray-200">
            <label
              class="flex gap-1 justify-center items-center self-stretch px-2 py-1 my-auto font-bold text-center whitespace-nowrap rounded border border-gray-300 min-h-8 text-blue-950 cursor-pointer">
              <span class="gap-2 self-stretch my-auto">Choose</span>
              <input type="file" (change)="onFileSelected($event)" class="hidden" accept=".pdf,.jpg,.jpeg,.png" />
            </label>
            <p
              class="flex-1 shrink gap-2.5 self-stretch my-auto font-medium basis-4 min-w-60 text-neutral-500 truncate overflow-hidden text-ellipsis">
              {{ fileName || "Attach supporting file" }}
            </p>
          </div>
          <p class="gap-2.5 self-start mt-1 text-xs font-medium leading-none text-neutral-500">
            Supporting format: PDF, PNG and JPG under 5 mb
          </p>

          <div *ngIf="fileValidationErrors.length" class="mt-1 space-y-0.5">
            <p *ngFor="let err of fileValidationErrors" class="text-xs font-medium text-red-500 leading-snug">
              {{ err }}
            </p>
          </div>
        </div>

        <!-- Remarks -->
        <div class="mt-4 w-full">
          <label class="block w-full text-sm font-bold leading-none text-zinc-700 mb-1">
            Remarks
          </label>
          <div class="flex gap-2 items-start px-3 py-3 w-full text-base font-medium rounded-lg border border-gray-200">
            <textarea formControlName="remarks" placeholder="Tell more here"
              class="w-full min-h-24 outline-none border-none focus:ring-0 focus:border-transparent resize-none"
              formControlName="remarks"></textarea>
          </div>
        </div>
      </form>
    </main>

    <!-- Footer with Submit button -->
    <footer
      class="flex flex-col justify-center items-end px-8 py-4 w-full text-base font-bold text-white bg-white border-t border-solid border-t-[#C0C5C7] max-md:px-5">
      <button (click)="onSubmitenquiry()" [disabled]="partForm.invalid"
        class="flex gap-1 justify-center items-center p-3 rounded-lg bg-blue-950 w-[198px] disabled:opacity-50 disabled:cursor-not-allowed">
        <span class="gap-2 self-stretch my-auto">Submit</span>
      </button>
    </footer>
  </section>
</div>

<!-- grading-guide.component.html -->
<div *ngIf="isOpen" class="fixed inset-0 bg-black bg-opacity-50 z-40" (click)="closePartRequestForm()"></div>
<div
  class="fixed items-center justify-center rounded-lg bg-opacity-50 z-50 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
  *ngIf="isOpen">
  <section class="flex flex-col p-6 bg-white rounded-2xl max-w-[606px] max-md:px-5">
    <header
      class="flex flex-wrap gap-10 justify-between items-center w-full text-xl font-bold leading-snug text-black max-md:max-w-full cursor-pointer">
      <h2 class="flex flex-col justify-center self-stretch my-auto cursor-pointer">
        <span class="gap-6 self-stretch cursor-pointer">Grading Guide</span>
      </h2>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/13f7c2264c0761b5866ecb8269037fff38106680?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
        alt="Grading guide icon" class="object-contain shrink-0 self-stretch my-auto w-6 aspect-square cursor-pointer"
        (click)="closePartRequestForm()" />
    </header>

    <div class="flex flex-col justify-center items-start self-start mt-6 font-bold leading-none">
      <div class="flex gap-4 items-center">
        <div
          class="flex gap-1 items-center self-stretch px-1 my-auto w-20 text-lg text-green-700 whitespace-nowrap bg-green-300 rounded min-h-8">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/7225999b2de43c012b4d5a5e4d05ad49c586cc3e?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
            alt="Grade A icon" class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square" />
          <span class="self-stretch my-auto">Grade</span>
        </div>
        <p class="self-stretch my-auto text-xs text-black">
          Reliable & tested.
        </p>
      </div>

      <div class="flex gap-4 items-center self-stretch mt-4">
        <div
          class="flex gap-1 items-center self-stretch px-1 my-auto w-20 text-lg text-yellow-600 whitespace-nowrap rounded bg-yellow-600 bg-opacity-30 min-h-8">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/2e8be1f43282c43ae895e008c0cc39c6d2a713d2?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
            alt="Grade B icon" class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square" />
          <span class="self-stretch my-auto">Grade</span>
        </div>
        <p class="self-stretch my-auto text-xs text-black">
          Fully functional & minor imperfections.
        </p>
      </div>

      <div class="flex gap-4 items-center mt-4">
        <div
          class="flex gap-1 items-center self-stretch px-1 my-auto w-20 text-lg text-amber-800 whitespace-nowrap rounded bg-orange-500 bg-opacity-60 min-h-8">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/8e9f93fe5db31bc369305e8c7f0dc4ffa4039094?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
            alt="Grade C icon" class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square" />
          <span class="self-stretch my-auto">Grade</span>
        </div>
        <p class="self-stretch my-auto text-xs text-black">
          Functional, but few scratches visible
        </p>
      </div>
    </div>

    <h3 class="flex gap-6 items-center mt-6 w-full text-lg font-bold leading-none text-black max-md:max-w-full">
      <span class="gap-6 self-stretch my-auto min-w-60">
        How grading has been decided?
      </span>
    </h3>
    <div class="flex flex-wrap p-3 mt-6 w-full rounded-2xl bg-blue-200 bg-opacity-20">
      <!-- Parameter Column -->
      <div class="w-[156px] flex flex-col border-r border-black text-sm font-medium text-black">
        <div class="p-2.5 text-lg font-bold text-blue-950 border-b border-[color:var(--Primary-Deep-Blue,#0A0A5F)]">
          Parameter
        </div>
        <div class="p-2.5 bg-white border-b border-r border-[color:var(--Primary-Deep-Blue,#0A0A5F)]">
          No Physical Damage
        </div>
        <div class="p-2.5 border-b border-[color:var(--Primary-Deep-Blue,#0A0A5F)]">
          No Abnormal Voice
        </div>
        <div class="p-2.5 bg-white border-r border-[color:var(--Primary-Deep-Blue,#0A0A5F)]">
          No Leakages
        </div>
      </div>

      <!-- Grades Column -->
      <div class="flex-1 flex flex-col min-w-60 text-lg font-bold text-blue-950">
        <div
          class="flex divide-x divide-[color:var(--Primary-Deep-Blue,#0A0A5F)] border-b border-[color:var(--Primary-Deep-Blue,#0A0A5F)]">
          <div class="flex-1 p-2.5">Quality A</div>
          <div class="flex-1 p-2.5">Quality B</div>
          <div class="flex-1 p-2.5">Quality C</div>
        </div>
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dff29728b3739b35ef0f063c183a80dd590c70d?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
          alt="Grade A criteria" class="w-full object-contain aspect-[9.43] min-h-10" />
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/6f6fca512ab2bf4951fa578244a8629e843a1f1f?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
          alt="Grade B criteria" class="w-full object-contain aspect-[9.43] min-h-10" />
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/81de072bdfb3d64873e7c67612ae08c6e5b76150?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
          alt="Grade C criteria" class="w-full object-contain aspect-[9.43] min-h-10" />
      </div>

      <!-- <div *ngIf="isOpen" class="fixed inset-0 bg-black bg-opacity-50 z-[90]" (click)="closePartRequestForm()"></div> -->
    </div>
  </section>
</div>
@if (isMobile) {
<section class="fixed bottom-0 left-0 right-0 flex flex-col justify-center px-3 py-2 bg-white shadow-sm w-full z-[11]">
  <div class="flex gap-1 justify-center items-center self-start">
    <span class="self-stretch my-auto text-sm font-medium leading-none text-neutral-500">
      Total amount:
    </span>
    <span class="self-stretch my-auto text-base font-bold text-black">
      {{
      priceBreakup?.total_amount
      ? priceBreakup.total_amount
      : productDetailData?.part_detail?.discounted_price ||
      productDetailData?.part_detail?.price_s
      }}
    </span>
  </div>

  <div class="flex gap-2 mt-1 w-full text-sm font-medium leading-none">
    <!-- Animated Cart Button -->
    <button [disabled]="isProductLocked()"
      class="cart-btn flex items-center justify-center gap-1 p-2 w-full whitespace-nowrap bg-blue-500 rounded-lg min-h-10"
      [class.added]="itemAddedToCart" [class.disabled]="isProductLocked()" (click)="
          itemAddedToCart
            ? goToCart()
            : addToCart(productDetailData?.part_detail?.inventory_id)
        ">
      <div class="cart-content cart-content-add">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"
          class="cart-icon-svg">
          <rect width="20" height="20" transform="translate(0.5)" fill="none" />
          <path
            d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
            fill="white" />
        </svg>
        <span class="btn-text text-base font-bold text-white">Add to Cart</span>
      </div>
      <div class="cart-content cart-content-go">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
          class="cart-icon-svg w-5 h-5">
          <path
            d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
            fill="white" />
        </svg>
        <span class="btn-text text-base font-bold text-white">Go to Cart</span>
      </div>
    </button>

    <button [disabled]="isProductLocked()" [ngClass]="
          isProductLocked()
            ? 'flex items-center justify-center gap-1 p-2 w-full text-gray-400 border border-gray-400 rounded-lg min-h-10 cursor-not-allowed'
            : 'flex items-center justify-center gap-1 p-2 w-full text-blue-500 border border-blue-500 rounded-lg min-h-10'
        " (click)="onBuyNowClick()">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/e1d0ce3367710415ccc725fba6749afd03dcdc64?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
        class="w-5 aspect-square object-contain" alt="Buy now icon" />
      <span>{{ isScrapPart ? "Book Now" : "Buy Now" }}</span>
    </button>
  </div>
</section>

<!-- Spacer so content isn't hidden behind sticky Add to Cart / Buy Now bar -->
<div class="pb-24"></div>
}

<!-- Backdrop -->
<div class="fixed inset-0 z-50 transition-opacity ease-in-out duration-300 bg-black bg-opacity-50"
  [class.opacity-0]="!isBuyNowPopupOpen" [class.opacity-100]="isBuyNowPopupOpen"
  [class.pointer-events-none]="!isBuyNowPopupOpen" *ngIf="isBuyNowPopupOpen" (click)="closeBuyNowPopup()"></div>

<!-- Popup -->
<div
  class="pdp-buy-now-popup fixed inset-y-0 right-0 w-full max-w-[400px] sm:max-w-[90vw] md:max-w-[400px] z-[60] transition-transform ease-in-out duration-300 transform"
  [class.translate-x-full]="!isBuyNowPopupOpen" [class.translate-x-0]="isBuyNowPopupOpen" *ngIf="isBuyNowPopupOpen">
  <section class="flex flex-col bg-white h-full max-h-screen shadow-xl w-full text-[15px] leading-6 text-neutral-800"
    (click)="$event.stopPropagation()">
    <!-- Scrollable Content Area -->
    <div class="flex-1 overflow-y-auto overscroll-contain">
      <!-- Header -->
      <header class="flex justify-between items-center px-4 sm:px-6 py-3 sm:py-4 border-b">
        <h1 class="text-xl sm:text-2xl font-bold text-[#0A0A5F] tracking-normal">
          {{ isScrapPart ? "Book Now" : "Buy Now" }}
        </h1>
        <button type="button" class="p-1 border-0 bg-transparent text-[#0A0A5F]" (click)="closeBuyNowPopup()"
          aria-label="Close">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/36d3ab0a730378ef51331509c45c2e1547024960?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
            class="w-6 h-6 sm:w-7 sm:h-7" alt="Close" />
        </button>
      </header>

      <!-- Delivery/Pickup Options -->
      <!-- <div class="flex flex-row gap-3 px-4 sm:px-6 pt-4 pb-2">
        <button *ngIf="!isScrapPart" type="button" (click)="selectDeliveryOption('home')"
          [class.bg-blue-50]="selectedDeliveryOption === 'home'"
          [class.border-[#0A0A5F]]="selectedDeliveryOption === 'home'"
          [class.text-[#0A0A5F]]="selectedDeliveryOption === 'home'"
          [class.border-gray-300]="selectedDeliveryOption !== 'home'"
          [class.text-gray-700]="selectedDeliveryOption !== 'home'"
          class="flex-1 flex items-center gap-2 px-3 py-3 border rounded-lg text-left">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/94c995730d8e0c9c3e5a9d9bad5c6160da8a8d09?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
            class="w-5 h-5 shrink-0" alt="Home Delivery" />
          <span class="flex flex-col min-w-0">
            <span class="text-sm font-bold leading-5">Home Delivery</span>
            <span class="text-xs font-normal text-gray-500 leading-4">Get Delivery by 24th Feb</span>
          </span>
        </button>
        <button type="button" (click)="selectDeliveryOption('store')"
          [class.bg-blue-50]="selectedDeliveryOption === 'store' || isScrapPart" [class.border-[#0A0A5F]]="
            selectedDeliveryOption === 'store' || isScrapPart
          " [class.text-[#0A0A5F]]="
            selectedDeliveryOption === 'store' || isScrapPart
          " [class.border-gray-300]="
            selectedDeliveryOption !== 'store' && !isScrapPart
          " [class.text-gray-700]="
            selectedDeliveryOption !== 'store' && !isScrapPart
          " class="flex-1 flex items-center gap-2 px-3 py-3 border rounded-lg text-left">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/6ecf169800a48db3ea2a961ae2ddeff70d816591?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
            class="w-5 h-5 shrink-0" alt="Store Pickup" />
          <span class="flex flex-col min-w-0">
            <span class="text-sm font-bold leading-5">Store Pickup</span>
            <span class="text-xs font-normal text-gray-500 leading-4">Pickup after 24th Feb</span>
          </span>
        </button>
      </div> -->
      @if (selectedDeliveryOption === "home") {
      <div class="mx-4 sm:mx-6 mt-3 bg-[#F5F9FE] rounded-lg p-3" *ngIf="
            selectedDeliveryOption === 'home' &&
            hasAddress(userData?.shipping_address)
          ">
        <div class="flex items-start justify-between gap-2 mb-1">
          <div class="text-sm font-bold text-[#0A0A5F] leading-5 min-w-0">
            Deliver:
            {{
            userData?.shipping_address?.company_name
            ? userData?.shipping_address?.company_name
            : userData?.shipping_address?.receiver_name
            ? userData?.shipping_address?.receiver_name
            : (userData?.first_name + " " + userData?.last_name
            | slice: 0 : 20)
            }}
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <span class="bg-white text-xs px-2 py-0.5 rounded-full font-medium text-neutral-500 border border-zinc-300">
              {{ (userData?.shipping_address?.address_type || "home") | titlecase }}
            </span>
            <button class="px-2 py-1 text-[#0A0A5F] border border-[#0A0A5F] rounded-md text-xs font-bold"
              (click)="openAddressSelection('shipping')" type="button">
              Change
            </button>
          </div>
        </div>
        <address class="text-sm leading-5 text-neutral-500 not-italic">
          {{ formatAddress(userData?.shipping_address) }}
        </address>
        <p class="mt-2 text-[13px] leading-5 text-gray-800" *ngIf="
              userData?.billing_address?.id === userData?.shipping_address?.id
            ">
          Note - Delivery details and billing details will be the same
        </p>
      </div>

      @if (
      selectedDeliveryOption === "home" &&
      !hasAddress(userData?.shipping_address) &&
      !hasAddress(userData?.billing_address)
      ) {
      <div class="flex items-center justify-between gap-3 mx-4 sm:mx-6 mt-3 bg-[#F5F9FE] rounded-lg px-3 py-3">
        <span class="text-sm font-bold text-[#0A0A5F] leading-5">
          Add address to check for delivery & services
        </span>
        <button
          class="shrink-0 px-3 py-1.5 text-xs font-bold text-[#0A0A5F] border border-[#0A0A5F] rounded-md hover:bg-blue-50"
          (click)="openAddressSelection('shipping')">
          Add address
        </button>
      </div>
      }
      }
      @if (selectedDeliveryOption === "store") {
      <div class="mx-4 sm:mx-6 mt-3 bg-[#F5F9FE] rounded-lg p-3">
        <div class="text-sm font-bold text-[#0A0A5F] leading-5">
          Store Pickup:
          {{
          productDetailData?.seller_detail?.seller_name ||
          productDetailData?.seller_name ||
          productDetailData?.part_detail?.seller_name ||
          productDetailData?.seller_detail?.branch_name ||
          "Store location not available"
          }}
        </div>
        <address class="mt-2 text-sm leading-5 text-neutral-500 not-italic">
          {{ productDetailData?.seller_detail?.address_1 }}
          <ng-container *ngIf="productDetailData?.seller_detail?.address_2">, {{
            productDetailData?.seller_detail?.address_2 }}</ng-container>
          <ng-container *ngIf="productDetailData?.seller_detail?.address_3">, {{
            productDetailData?.seller_detail?.address_3 }}</ng-container>
        </address>
        <p class="mt-2 text-[13px] leading-5 text-gray-800">
          Note - Pickup between 9:00 am to 6:00 pm
        </p>
      </div>
      }

      <!-- Billing Block (home delivery + scrap store pickup) -->
      <div class="mx-4 sm:mx-6 mt-3 bg-[#F5F9FE] rounded-lg p-3" *ngIf="shouldShowBillingBlock()">
        <div class="flex items-start justify-between gap-2 mb-1">
          <div class="text-sm font-bold text-[#0A0A5F] leading-5 min-w-0">
            Billing: {{ getBillingDisplayName() | slice: 0 : 20 }}
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <span class="bg-white text-xs px-2 py-0.5 rounded-full font-medium text-neutral-500 border border-zinc-300"
              *ngIf="getBillingAddressType()">
              {{ getBillingAddressType() | titlecase }}
            </span>
            <button class="px-2 py-1 text-[#0A0A5F] border border-[#0A0A5F] rounded-md text-xs font-bold"
              (click)="onBillingChangeClick()" type="button">
              Change
            </button>
          </div>
        </div>
        <address class="text-sm leading-5 text-neutral-500 not-italic">
          {{ billingAddress }}
        </address>
        <p class="mt-2 text-[13px] leading-5 text-gray-800" *ngIf="billingGST !== 'No GSTIN'">
          GST: {{ billingGST }}
        </p>
      </div>

      @if (
      isScrapPart &&
      !hasAddress(userData?.billing_address) &&
      !hasAddress(userData?.shipping_address)
      ) {
      <div class="flex items-center justify-between gap-3 mx-4 sm:mx-6 mt-3 bg-[#F5F9FE] rounded-lg px-3 py-3">
        <span class="text-sm font-bold text-[#0A0A5F] leading-5">
          Add billing address for invoice & pickup
        </span>
        <button
          class="shrink-0 px-3 py-1.5 text-xs font-bold text-[#0A0A5F] border border-[#0A0A5F] rounded-md hover:bg-blue-50"
          (click)="openAddressSelection('billing')">
          Add address
        </button>
      </div>
      }

      <!-- Billing options -->
      <div class="px-4 sm:px-6 pt-4">
        <div class="flex flex-wrap gap-x-4 gap-y-2 items-center">
          <label class="flex items-center gap-2 text-sm font-bold text-black leading-5">
            <input type="radio" name="billing" [checked]="selectedBillingOption === 'Billing'"
              (change)="onBillingOptionChange('Billing')" class="w-4 h-4 accent-[#0A0A5F]" />
            Add different Billing details
          </label>
          <label *ngIf="canAddGstDetails" class="flex items-center gap-2 text-sm font-bold text-black leading-5">
            <input type="radio" name="billing" [checked]="selectedBillingOption === 'gstin'"
              (change)="onBillingOptionChange('gstin')" class="w-4 h-4 accent-[#0A0A5F]" />
            Add GSTIN
          </label>
        </div>
      </div>

      <!-- Product Section -->
      <div class="flex flex-row gap-3 px-4 sm:px-6 pt-4">
        <div class="relative shrink-0">
          <img [src]="productDetailData?.part_detail?.part_image_path[0]"
            class="w-[120px] h-[120px] rounded-lg object-cover" alt="Product" />
          @if (productDetailData?.part_detail?.quality_s) {
          <div class="absolute top-2 left-2 z-10 flex items-center px-2 py-1 rounded shadow font-bold text-xs"
            [ngClass]="
                productDetailData?.part_detail?.quality_s === 'A'
                  ? 'bg-green-100 text-green-800'
                  : productDetailData?.part_detail?.quality_s === 'B'
                    ? 'bg-yellow-100 text-yellow-800'
                    : productDetailData?.part_detail?.quality_s === 'C'
                      ? 'bg-orange-100 text-orange-800'
                      : 'bg-green-100 text-green-800'
              ">
            <svg width="20" height="20" class="mr-1" viewBox="0 0 24 24">
              <rect width="24" height="24" rx="4" [attr.fill]="
                    productDetailData?.part_detail?.quality_s === 'A'
                      ? '#01811D'
                      : productDetailData?.part_detail?.quality_s === 'B'
                        ? '#B8860B'
                        : productDetailData?.part_detail?.quality_s === 'C'
                          ? '#D35400'
                          : '#01811D'
                  " />
              <text x="12" y="16" text-anchor="middle" font-size="12" font-family="Arial, sans-serif" fill="white">
                {{ productDetailData?.part_detail?.quality_s }}
              </text>
            </svg>
            Quality
          </div>
          }
        </div>
        <div class="flex-1 min-w-0">
          <div class="font-bold text-sm leading-5 text-black line-clamp-2">
            {{ productDetailData?.part_detail | productName }}
          </div>
          <div class="text-[13px] leading-5 text-gray-500 mt-1"
            *ngIf="productDetailData?.part_detail?.part_type === 'Used Part'">
            {{ productDetailData?.part_detail?.TEVM_VEHICLE_MAKE_s }},
            {{ productDetailData?.part_detail?.model }},
            {{ productDetailData?.part_detail?.year_of_manufacture }},
            {{ productDetailData?.part_detail?.GROUP_NAME_s }}
          </div>
          <div class="flex items-center gap-2 mt-2 flex-wrap">
            <span class="font-bold text-base" *ngIf="!isScrapPart">₹{{
              productDetailData?.part_detail?.discounted_price
              ? productDetailData?.part_detail?.discounted_price.toLocaleString()
              : (productDetailData?.part_detail?.price_s.toLocaleString()
              | number: "1.2-2")
              }}</span>
            <span class="font-bold text-base" *ngIf="isScrapPart">
              ₹{{ getBasePrice() > 0 ? (getBasePrice() | number: "1.2-2") : '0' }}
            </span>
            <span class="line-through text-xs text-gray-400" *ngIf="
                productDetailData?.part_detail?.discount_percentage &&
                productDetailData?.part_detail?.discount_percentage > 0 &&
                getOriginalBasePrice() > getBasePrice()
              ">₹{{ getOriginalBasePrice() | number: "1.2-2" }}</span>
            <span class="bg-emerald-800 text-white text-xs px-2 rounded-full" *ngIf="
                productDetailData?.part_detail?.discount_percentage &&
                productDetailData?.part_detail?.discount_percentage > 0
              ">{{ productDetailData?.part_detail?.discount_percentage }}%
              Off</span>
          </div>
          <div class="text-[13px] leading-5 mt-2 text-gray-700">
            Sold by:
            <span class="font-bold text-black">{{
              productDetailData?.seller_detail?.seller_name ||
              productDetailData?.seller_name ||
              productDetailData?.part_detail?.seller_name ||
              productDetailData?.seller_detail?.branch_name
              }}</span>
          </div>
          <div class="text-[13px] leading-5 mt-1 text-[#0A0A5F] font-medium" *ngIf="isScrapPart">
            Quantity:
            {{
            (unit === "ton" ? quantity * 1000 : quantity) | number: "1.0-2"
            }}
            <ng-container *ngIf="isOilProductWithLiter(productDetailData?.part_detail)">
              Ltr
            </ng-container>
            <ng-container *ngIf="!isOilProductWithLiter(productDetailData?.part_detail)">
              Kg
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Coupon Section -->
      <div class="px-4 sm:px-4 pt-4">
        <div
          class="flex flex-col justify-center p-3 mt-4 w-full font-bold rounded-lg bg-blue-200 bg-opacity-20 max-md:max-w-full">
          <div class="flex gap-10 justify-between items-start w-full">
            <div class="flex gap-2 items-start">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/ad6a63e7a20f03d1faf97eb2c88638f91fa77039?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
                class="object-contain shrink-0 w-6 aspect-square" alt="Coupon" />
              <div class="flex flex-col justify-center">
                <h3 class="text-base text-blue-950">Coupons</h3>
                <p class="mt-1 text-sm leading-5 text-emerald-800" *ngIf="!selectedCoupon">
                  {{ availableCoupons.length || 0 }} Coupons available
                </p>
                <p class="mt-1 text-sm leading-5 text-emerald-800" *ngIf="selectedCoupon">
                  <span class="font-semibold">{{
                    selectedCoupon.coupon_code
                    }}</span>
                  applied • Save ₹{{ selectedCoupon.savings }}
                </p>
              </div>
            </div>
            <button type="button"
              class="flex gap-1 justify-center items-center text-base text-center text-blue-500 rounded-xl"
              (click)="openCouponPopup()">
              <span class="gap-2 self-stretch my-auto text-blue-500">
                View All
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Price Details Section -->
      <div class="px-4 sm:px-6 pt-5 pb-4">
        <h3 class="text-base font-bold text-[#0A0A5F] leading-6 mb-3">
          Price Details
        </h3>
        <div class="space-y-2 text-sm leading-6 text-neutral-600">
          <div class="flex justify-between">
            <span>Sub Total</span>
            <span class="text-gray-900">₹{{ getBasePrice() > 0 ? (getBasePrice() | number: "1.2-2") : '0' }}</span>
          </div>

          <div class="flex justify-between" *ngIf="hasBookingAmount()">
            <span>
              Scrap Booking Amount
              <span *ngIf="getBookingPercentage()" class="text-xs font-bold text-blue-600 ml-1">
                ({{ getBookingPercentage() }}%)
              </span>
            </span>
            <span class="text-gray-900">+ ₹{{ formatPriceBreakup(priceBreakup?.scrap_booking_amount ||
              productDetailData?.part_detail?.booking_amount) }}</span>
          </div>
          <label *ngIf="hasBookingAmount() || payFullAmount"
            class="flex items-start gap-2 cursor-pointer text-[13px] leading-5 text-neutral-700">
            <input type="checkbox" class="mt-0.5 w-4 h-4 rounded border-gray-300 accent-[#0A0A5F]"
              [(ngModel)]="payFullAmount" (ngModelChange)="onPayFullAmountChange($event)"
              aria-label="Pay full amount now" />
            <span>Pay full amount now instead of booking amount.</span>
          </label>

          <div *ngIf="hasBookingAmount() && !payFullAmount && getBalanceAmount() > 0"
            class="flex items-start gap-2 mt-2 p-2.5 bg-blue-50/70 rounded-lg border border-blue-100 text-[#0A0A5F]">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"
              class="mt-0.5 shrink-0 text-blue-700">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path
                d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
            </svg>
            <p class="text-[#0A0A5F] font-medium text-xs leading-relaxed">
              The balance amount of ₹{{ getBalanceAmount() | number: "1.2-2" }} is to be paid at the time of store
              pickup.
            </p>
          </div>

          <div class="flex justify-between">
            <span>Discount on Base Price</span>
            <span class="text-green-600">- ₹{{ formatPriceBreakup(priceBreakup?.discount) }}</span>
          </div>

          <div class="flex justify-between">
            <span>Platform Charges</span>
            <span class="text-gray-900">+ ₹{{ formatPriceBreakup(priceBreakup?.platform_charges) }}</span>
          </div>

          <div class="flex justify-between">
            <span>Delivery Charges</span>
            <span class="font-medium text-neutral-800">{{ (priceBreakup?.delivery_charges &&
              +priceBreakup?.delivery_charges > 0) ? ('+ ₹' + formatPriceBreakup(priceBreakup?.delivery_charges)) :
              'Free' }}</span>
          </div>

          <div class="flex justify-between">
            <span>GST</span>
            <span class="text-gray-900">+ ₹{{ formatPriceBreakup(priceBreakup?.gst_amount) }}</span>
          </div>

          <div class="flex justify-between">
            <span>TCS</span>
            <span class="text-gray-900">+ ₹{{ formatPriceBreakup(priceBreakup?.tcs_amount) }}</span>
          </div>

          <div class="flex justify-between">
            <span>Offer Discount</span>
            <span class="text-green-600">- ₹{{ formatPriceBreakup(priceBreakup?.offer_discount) }}</span>
          </div>
        </div>

        <div class="flex justify-between mt-4 pt-3 border-t font-bold text-base text-[#0A0A5F] leading-6">
          <span>Total Amount</span>
          <span>₹{{ getPayableAmount() > 0 ? (getPayableAmount() | number: "1.2-2") : '0' }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="paymentErrorMessage"
      class="mx-4 sm:mx-6 mt-3 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm leading-5">
      {{ paymentErrorMessage }}
    </div>
    <!-- Payment Button - Fixed Footer -->
    <div class="flex justify-between items-center px-4 sm:px-6 py-4 border-t bg-white flex-shrink-0 gap-3">
      <div class="min-w-0">
        <div class="text-[13px] leading-5 text-gray-500">Total Amount</div>
        <div class="font-bold text-lg leading-6 text-[#0A0A5F]">
          ₹{{ getPayableAmount() > 0 ? (getPayableAmount() | number: "1.2-2") : '0' }}
        </div>
      </div>
      <div class="flex items-center gap-2 flex-shrink-0">
        <button type="button"
          class="bg-[#0A0A5F] text-white font-bold px-4 sm:px-5 py-2.5 rounded-lg text-sm leading-5 shrink-0 cursor-pointer"
          (click)="onMakeEnquiry()" [disabled]="!canPlaceOrder" [class.opacity-60]="!canPlaceOrder">
          Enquire Now
        </button>
        <button class="bg-[#0A0A5F] text-white font-bold px-4 sm:px-5 py-2.5 rounded-lg text-sm leading-5 shrink-0"
          [disabled]="!canPlaceOrder" [class.opacity-60]="!canPlaceOrder" (click)="onMakePayment()">
          Make Payment
        </button>
      </div>
    </div>
  </section>
</div>
<app-address *ngIf="showBillingPopup" (close)="onCloseBillingDetails()" (save)="onSaveAddressDetails($event)"
  [type]="addressType"></app-address>
<app-gst *ngIf="showGSTINPopup" (close)="onCloseGSTINPopup()" (save)="onSaveGSTINDetails($event)"></app-gst>
<!-- 
<app-billing-details *ngIf="showBillingPopup" (close)="onCloseBillingDetails()"></app-billing-details>
<app-gstin-details *ngIf="showGSTINPopup" (close)="onCloseGSTINPopup()" (save)="onSaveGSTINDetails($event)"></app-gstin-details> -->

<!-- Address Selection Popup -->
<div *ngIf="showAddressSelectionPopup" class="fixed inset-0 bg-black bg-opacity-50 z-[90]"
  (click)="closeAddressSelection()"></div>

<section
  class="bg-white max-w-[484px] fixed bottom-0 left-0 right-0 sm:right-0 sm:left-auto sm:top-0 sm:bottom-auto h-[90vh] sm:h-full max-h-[90vh] sm:max-h-full shadow-lg transform transition-transform duration-300 z-[100] w-full sm:w-[484px] rounded-2xl sm:rounded-none max-md:flex max-md:flex-col"
  [ngClass]="
    showAddressSelectionPopup
      ? 'translate-y-0 sm:translate-y-0 sm:translate-x-0'
      : 'translate-y-full sm:translate-y-0 sm:translate-x-full'
  " *ngIf="showAddressSelectionPopup">
  <!-- Header -->
  <header
    class="flex flex-col justify-center px-6 py-4 w-full text-2xl font-bold leading-none bg-white max-md:rounded-t-2xl border-b border-solid border-b-[color:var(--Input-field-Stroke,#D4D4D4)] text-blue-950 max-md:px-5 max-md:shrink-0">
    <div class="flex gap-10 justify-between items-start w-full">
      <h1>
        Select {{ addressType === "shipping" ? "Shipping" : "Billing" }} Address
      </h1>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/8b6c08b8f398b49c9e660c78975ef334b44714be?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
        alt="Close" class="object-contain shrink-0 w-8 aspect-square cursor-pointer"
        (click)="closeAddressSelection()" />
    </div>
  </header>

  <!-- Scrollable Content -->
  <div
    class="overflow-y-auto px-6 mt-6 pb-32 h-[calc(100vh-132px)] max-md:px-5 max-md:mt-4 max-md:pb-4 max-md:flex-1 max-md:min-h-0">
    <div *ngFor="let address of addresses; let i = index" [ngClass]="{ 'mt-2': i > 0 }">
      <article class="flex flex-col justify-center py-2 w-full bg-white">
        <div class="flex gap-2 items-start w-full rounded-lg">
          <input type="radio" class="object-contain shrink-0 w-4 aspect-square cursor-pointer"
            [checked]="selectedAddressId === address.id" (change)="selectAddress(address.id)" [value]="address.id" />
          <div class="flex flex-col flex-1 min-w-60">
            <header class="flex gap-1 items-center font-bold">
              <h3 class="text-black whitespace-nowrap overflow-hidden text-ellipsis">
                {{
                address?.receiver_name
                ? address?.receiver_name
                : address?.company_name
                ? address?.company_name
                : userData?.account_name
                }},
              </h3>
              <span class="text-black">{{ address?.pincode }}</span>
            </header>
            <p class="mt-1 font-medium leading-6 text-neutral-500">
              {{ address?.address_1 }}
              <span *ngIf="address?.land_mark">, {{ address?.land_mark }}</span>
              <span *ngIf="address?.city">, {{ address?.city }}</span>
              <span *ngIf="address?.state">, {{ address?.state }}</span>
              <span *ngIf="address?.pincode">, {{ address?.pincode }}</span>
            </p>
          </div>
        </div>
      </article>

      <div class="text-sm text-gray-500" *ngIf="addresses.length === 0">
        No addresses found
      </div>
    </div>
  </div>

  <!-- Footer -->
  <footer
    class="flex flex-wrap gap-6 items-center px-6 py-2 w-full font-bold text-center bg-white border-t border-solid border-t-[color:var(--Neutrals-Light-Gray,#C0C5C7)] absolute bottom-0 max-md:px-5 max-md:relative max-md:shrink-0">
    <button class="flex flex-1 gap-1 justify-center items-center p-3 rounded-lg border text-blue-950"
      (click)="addNewAddress()">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/2d38e86aa9802372fe8d74f0ea1246427ad41107?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
        alt="Add" class="w-6 aspect-square" />
      <span class="whitespace-nowrap">Add {{ addressType === "shipping" ? "" : "Billing" }} Address</span>
    </button>

    <button class="flex flex-1 gap-1 justify-center items-center p-3 text-white rounded-lg bg-blue-950"
      (click)="applyAddressSelection()">
      <span>Apply</span>
    </button>
  </footer>
</section>

<!-- Coupon Popup -->
<app-coupon *ngIf="showCouponPopup" (close)="closeCouponPopup()" (save)="onSaveCouponDetails($event)"
  [availableCoupons]="availableCoupons" [currentSelectedCoupon]="selectedCoupon"></app-coupon>

<!-- Login Popup Modal -->
<div *ngIf="showLoginModal" id="authentication-modal"
  class="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50" tabindex="-1" aria-hidden="true" (click)="onLoginBackdropClick($event)">
  <div
    class="relative bg-white rounded-lg shadow w-full h-full sm:w-auto sm:h-auto sm:max-w-4xl sm:max-h-[90vh] sm:overflow-auto">
    <!-- <button
      class="absolute top-2 right-2 text-gray-500 hover:text-gray-800 login hidden sm:flex z-10"
      (click)="closeLoginPopup()"
      aria-label="Close"
    >
      ✕
    </button> -->

    <app-login (loginSuccess)="closeLoginPopup()" [productData]="productDetailData" [actionType]="currentAction">
    </app-login>
  </div>
</div>

<!-- Popup Box -->
<div *ngIf="isPopupVisible" class="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
  <div class="p-6 bg-slate-300 rounded-lg flex flex-col justify-start items-start gap-3 relative w-[500px]">
    <!-- Header -->
    <div class="flex justify-between items-start w-full cursor-pointer" (click)="togglePopup()">
      <div class="text-Primary-Deep-Blue text-lg font-bold leading-normal">
        Open Box Delivery
      </div>
      <button (click)="togglePopup()" aria-label="Close"
        class="w-6 h-6 flex items-center justify-center text-black font-bold text-lg">
        &times;
      </button>
    </div>

    <!-- Description -->
    <div class="text-Text-Caption text-sm font-medium leading-tight">
      Shop with confidence! With Open Box Delivery, you can inspect your order
      before accepting it.
    </div>

    <!-- How it works -->
    <div class="w-full">
      <div class="text-Primary-Deep-Blue text-base font-bold mb-2">
        How it works?
      </div>
      <div class="text-sm text-Text-Caption space-y-1">
        <p class="whitespace-nowrap">
          <strong>Open at delivery</strong> – The agent unboxes your order.
        </p>
        <p class="whitespace-nowrap">
          <strong>Inspect quickly</strong> – Check for damage, missing items, or
          wrong products.
        </p>
        <p class="whitespace-nowrap">
          <strong>Decide</strong> – Accept if all is good or return instantly.
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Trigger Button -->
<!-- <button (click)="openSocialSharePopup()" class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
  Share This Product
</button> -->

<!-- Modal -->
<div *ngIf="isSocialShareOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white w-full max-w-2xl rounded-lg shadow-lg p-6 relative">
    <!-- Close Button -->
    <button (click)="closeSocialSharePopup()" class="absolute top-3 right-3">
      <!-- <img src="/src/assets/location.png"alt="Close" class="w-5 h-5" /> -->
      X
    </button>

    <!-- Modal Header -->
    <div class="text-lg font-semibold mb-4 text-center">Share this product</div>

    <!-- Social Icons -->
    <div class="flex justify-around items-center gap-4 py-4">
      <a title="Facebook" href="https://www.facebook.com/sharer.php?u={{ pageURL }}" target="_blank"
        rel="noopener noreferrer" class="hover:opacity-80 transition-opacity">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#1877F2" viewBox="0 0 24 24">
          <path
            d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      </a>
      <a title="WhatsApp" href="https://wa.me?text={{ pageURL }}" target="_blank" rel="noopener noreferrer"
        class="hover:opacity-80 transition-opacity">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#25D366" viewBox="0 0 24 24">
          <path
            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
        </svg>
      </a>
      <a title="Instagram" href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"
        class="hover:opacity-80 transition-opacity">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#E4405F" viewBox="0 0 24 24">
          <path
            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
        </svg>
      </a>
      <a title="Twitter" href="https://twitter.com/intent/tweet?url={{ pageURL }}" target="_blank"
        rel="noopener noreferrer" class="hover:opacity-80 transition-opacity">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#1DA1F2" viewBox="0 0 24 24">
          <path
            d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
        </svg>
      </a>
      <a title="Gmail" href="https://mail.google.com/mail/?view=cm&fs=1&to=&su=Check%20out%20this%20product&body={{
          pageURL
        }}" target="_blank" rel="noopener noreferrer" class="hover:opacity-80 transition-opacity">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#EA4335" viewBox="0 0 24 24">
          <path
            d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z" />
        </svg>
      </a>
      <button (click)="copyMessage()" title="Copy link" class="hover:opacity-80 transition-opacity">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#666" viewBox="0 0 24 24">
          <path
            d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
        </svg>
      </button>
    </div>
  </div>
</div>

<!-- Scrap Certificate Modal -->
<app-scrap-certificate-modal></app-scrap-certificate-modal>